import { CategoriesResponse, MallsCategoriesFlatCategories } from '@shopby/shop-sdk'
import React, { useEffect, useRef, useState } from 'react'
import { isMobile, isIOS } from 'react-device-detect'
import TagManager, { DataLayerArgs } from 'react-gtm-module'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'
import { ProfileRootType } from '../../@types/auth'
import { OptionsFlatOption, OptionsMultiLevelOption } from '../../@types/product'
import { getProfile } from '../../api/auth'
import { getCart, postCart, postGuestCart, postGuestOrderSheets, postUserOrderSheets } from '../../api/cart'
import { getOrderList, postNaverOrderSheet } from '../../api/orderHistory'
import { getCategories, getOptions, getProductDetail, postRestock } from '../../api/product'
import { useMyContext } from '../../components/provider/MyProvider'
import { fadeIn, fadeOut, slideDown, slideUp } from '../../js/animation'
import {
  AFWebLinkType,
  handlePostMessage,
  moveToLinkNaver,
  RNPostMessage,
  sendSetAppsflyerEvent,
} from '../../js/postMessage'
import {
  findObjectsWithValue,
  formatNumberWithTruncation,
  getParsedLocalStorageItem,
  getParsedSessionStorageItem,
  plusComma,
} from '../../js/script'
import { BtnGroupQuantity } from '../../pages/cart/CartList'
import { colorObj } from '../color'
import { useAppContext } from '../provider/AppProvider'
import { useCartContext } from '../provider/CartProvider'
import { useCommonContext } from '../provider/CommonProvider'
import { addToCart } from '../../js/pixelEvent'
import { GTMItems } from '../../@types/dataLayerObject'

type memberGroup = {
  memberGroupDescription: string
  memberGroupName: string
  memberGroupNo: number
}

interface PropsType {
  headerText: string
  setIsModal: React.Dispatch<React.SetStateAction<boolean>>
  selectProductNo: string | undefined
  product?: any
  wonShopBol?: boolean
  listItem?: any
  promotion_id?: number
  promotion_name?: string
  idx?: number
  prevItems?: GTMItems[]
  promotionCategory2?: any
  promotionCategory?: any
  listId?: number
  listName?: string
}

type ExhibitionCategoryType = {
  depth1Label: string
  depth2Label: string
  depth3Label: string
}

/**
 * 모달 팝업 - 아래 꽉참
 *
 * @params {React.ReactNode} content - 콘텐츠 내용
 * @params {string} headerText - 모달 헤더 제목
 */

const imgURL = '/images'

export default function ProductModal({
  headerText,
  setIsModal,
  selectProductNo,
  product,
  wonShopBol,
  listItem,
  idx,
  promotion_id,
  promotion_name,
  prevItems,
  promotionCategory,
  promotionCategory2,
  listId,
  listName,
}: PropsType) {
  const { isAppView } = useAppContext()
  const { setToastMessage, setToastBtnMessage, setToastEvent, setIsToast, cartConfig } = useMyContext()
  const { setAddCart } = useCartContext()
  const { setIsLottie, setIsLogin, hasAccessToken } = useCommonContext()
  const navigate = useNavigate()
  const location = useLocation()

  const [closing, setClosing] = useState<boolean>(false) // 닫힘 애니메이션 적용에 필요
  const [isShowOptions, setShowOptions] = useState<boolean>(false) // 옵션 열기
  const [isShowSecondOptions, setIsShowSecondOptions] = useState<boolean>(false)
  const [isShowThirdOptions, setIsShowThirdOptions] = useState<boolean>(false)
  const [optionItem, setOptionItem] = useState<OptionsMultiLevelOption[]>([]) //옵션 아이템
  const [selectOption, setSelectOption] = useState<OptionsMultiLevelOption[]>([]) // 선택한 옵션
  const [allPrice, setAllPrice] = useState<number>(0) //총가격
  const [price, setPrice] = useState<number[]>([])
  const [productArray, setProductArray] = useState<any>([])
  const [selectOptionTitle, setSelectOptionTitle] = useState<string>('') //선택한 옵션 이름
  const [userData, setUserData] = useState<ProfileRootType>()
  const [selectSecondOption, setSelectSecondOption] = useState<OptionsMultiLevelOption[]>([])
  const [selectSecondOptionTitle, setSelectSecondOptionTitle] = useState<string>('')
  const [selectThirdOption, setSelectThirdOption] = useState<OptionsMultiLevelOption[]>([])
  const [selectThirdOptionTitle, setSelectThirdOptionTitle] = useState<string>('')
  const [selectFourOption, setSelectFourOption] = useState<OptionsMultiLevelOption[]>([])
  const [selectFourOptionTitle, setSelectFourOptionTitle] = useState<string>('')
  const [selectFiveOption, setSelectFiveOption] = useState<OptionsMultiLevelOption[]>([])
  const [selectFiveOptionTitle, setSelectFiveOptionTitle] = useState<string>('')
  const [selectCopy, setSelectCopy] = useState<any>([])
  const [checkChange, setCheckChange] = useState<boolean>(false)
  const [memberCheck, setMemberCheck] = useState<boolean>(false)
  const [isInMemberGroup, setIsInMemberGroup] = useState<boolean>(false)
  const [memberGroupCheck, setMemberGroupCheck] = useState<boolean>(false)
  const [floatOption, setFloatOption] = useState<OptionsFlatOption[]>([])
  const [firstPurchase, setFirstPurchase] = useState<boolean>(false) // 첫구매 확인인데 false가 첫구매, true가 첫구매아님
  const [wonShop, setWonShop] = useState<any>([])
  const [selectItem, setSelectItem] = useState<any>([])
  const [categoryItem, setCategoryItem] = useState<CategoriesResponse>()
  const [productCategory, setProductCategory] = useState<MallsCategoriesFlatCategories[]>([])
  const [filterCategory, setFilterCategory] = useState<MallsCategoriesFlatCategories[]>([])
  const [exhibitionCategory, setExhibitionCategory] = useState<ExhibitionCategoryType>()
  const [isNewWebview, setIsNewWebview] = useState<boolean>(false)

  const ProductModalRef = useRef<any>(null)

  useEffect(() => {
    getCategories().then((res) => {
      setCategoryItem(res.data)
    })
  }, [])

  useEffect(() => {
    const query = location.search
    if (query.includes('newwebview=true') && query.includes('direct=true')) {
      setIsNewWebview(true)
    } else {
      setIsNewWebview(false)
    }
  }, [location.pathname])

  useEffect(() => {
    if (location && location.pathname !== 'product' && listItem?.length > 0) {
      const foundItem = listItem.find((el: any) => el.productNo === Number(selectProductNo))
      if (foundItem) {
        setSelectItem(foundItem)
      }
    }
  }, [listItem, location, selectProductNo])
  //gtm
  useEffect(() => {
    if (promotionCategory2 && categoryItem !== undefined) {
      categoryItem?.flatCategories?.map((el: any) => {
        if (promotionCategory2 === promotionCategory) {
          if (Number(el.depth2CategoryNo) === Number(promotionCategory)) {
            setExhibitionCategory({
              depth1Label: el.depth1Label,
              depth2Label: el.depth2Label,
              depth3Label: '전체',
            })
          }
        } else {
          if (Number(el.depth3CategoryNo) === Number(promotionCategory2)) {
            setExhibitionCategory({
              depth1Label: el.depth1Label,
              depth2Label: el.depth2Label,
              depth3Label: el.depth3Label,
            })
          }
        }
      })
    } else {
      setExhibitionCategory({
        depth1Label: '전체',
        depth2Label: '',
        depth3Label: '',
      })
    }
  }, [promotionCategory2, promotionCategory, categoryItem])
  //카테고리 가져오기
  useEffect(() => {
    if (selectItem && categoryItem) {
      const splitNo = selectItem.displayCategoryNos?.split('|') || []

      const array = splitNo.flatMap((el: any) => findObjectsWithValue(categoryItem.flatCategories, el))

      setProductCategory(array)
    }
  }, [selectItem, categoryItem])
  // 브랜드 제외
  useEffect(() => {
    if (productCategory) {
      const filteredCategories = productCategory.filter((el: any) => el.depth1Label !== '브랜드')

      setFilterCategory(filteredCategories)
    }
  }, [productCategory])

  const closeModal = () => {
    setClosing(true)
    setTimeout(() => {
      setIsModal(false)
      setClosing(false)
    }, 300)
  }

  useEffect(() => {
    setIsLottie(true)
  }, [])
  //100원샵 상품
  useEffect(() => {
    if (product) {
      product.categories.map((el: any) => {
        if (el.fullCategoryLabel === '100원샵') {
          setWonShop((prev: any) => [...prev, el])
        }
      })
    }
  }, [product])
  //유저 구매했는지
  useEffect(() => {
    if (userData) {
      if (JSON.parse(userData.additionalInfo || '').shopifyUserOrder) {
        setFirstPurchase(true)
      }
    }
  }, [userData])
  //유저 구매했는지
  useEffect(() => {
    if (hasAccessToken) {
      getOrderList().then((res) => {
        if (res.data.items.length !== 0) {
          setFirstPurchase(true)
        }
      })
    }
  }, [location])
  //구매제한 확인
  useEffect(() => {
    if (selectProductNo) {
      getProductDetail(selectProductNo).then((res) => {
        setMemberCheck(res.data.limitations.memberOnly)
      })
    }
  }, [selectProductNo])

  useEffect(() => {
    if (!closing) {
      document.getElementsByTagName('body')[0].style.overflow = 'hidden'
    } else {
      document.getElementsByTagName('body')[0].style.overflow = 'unset'
    }
  }, [closing])

  useEffect(() => {
    let prices = 0
    price.map((el: number) => {
      prices += el
    })
    setAllPrice(prices)
  }, [price])

  useEffect(() => {
    if (selectOption.length !== 0) {
      let plusPrice = 0
      price.map((el: number) => {
        plusPrice += el
      })
      setAllPrice(plusPrice)
    }
  }, [price])
  //선택상품 옵션
  useEffect(() => {
    if (selectProductNo) {
      getOptions(selectProductNo)
        .then((res) => {
          setFloatOption(res.data.flatOptions)
          setOptionItem(res.data.multiLevelOptions)
          setIsLottie(false)
        })
        .catch((err) => {
          alert('옵션을 불러올 수 없습니다.')
          setIsLottie(false)
        })
    }
  }, [selectProductNo])

  const handleButtonClick = (url: string) => {
    window.open(url, '_blank')
  }

  useEffect(() => {
    if (hasAccessToken) {
      getProfile().then((res) => {
        setUserData(res.data)
        const memberGroups = res.data.memberGroups.filter((group: memberGroup) => group.memberGroupNo === 9229)
        setIsInMemberGroup(memberGroups.length > 0)
      })
    }
  }, [hasAccessToken])

  useEffect(() => {
    const productNo = product?.baseInfo?.productNo
    const memberProductNos = [123937623, 123937622, 123937621]
    const isMemberProduct = memberProductNos.includes(productNo)
    if (isInMemberGroup && isMemberProduct) setMemberGroupCheck(true)
  }, [product, isInMemberGroup])

  //옵션 장바구니가 원하는대로 변환
  useEffect(() => {
    if (!selectOption[0]?.children) {
      const array: any = []
      selectOption.map((el: any, idx: any) => {
        const obj = {
          productNo: selectProductNo,
          optionNo: el.optionNo,
          orderCnt: productArray[idx] ? productArray[idx].orderCnt : 1,
          channelType: null,
          cartNo: null,
        }
        array.push(obj)
        setProductArray(array)
      })
    }
  }, [selectOption])

  useEffect(() => {
    if (optionItem) {
      setSelectOptionTitle(optionItem[0]?.label)
      // setIsLottie(false);
    }
  }, [optionItem])

  useEffect(() => {
    if (selectOption) {
      if (selectOption[0]?.children) {
        setSelectSecondOptionTitle(selectOption[0]?.children[0]?.label)
      }
    }
  }, [selectOption])

  useEffect(() => {
    if (selectSecondOption) {
      if (selectSecondOption[0]?.children) {
        setSelectThirdOptionTitle(selectSecondOption[0]?.children[0]?.label)
      }
    }
  }, [selectSecondOption])
  useEffect(() => {
    if (selectThirdOption) {
      if (selectThirdOption[0]?.children) {
        setSelectFourOptionTitle(selectThirdOption[0]?.children[0]?.label)
      }
    }
  }, [selectThirdOption])

  useEffect(() => {
    if (selectFourOption) {
      if (selectFourOption[0]?.children) {
        setSelectFourOptionTitle(selectSecondOption[0]?.children[0]?.label)
      }
    }
  }, [selectFourOption])
  return (
    <>
      <ModalWrap>
        <ModalBox closing={closing} isIOS={isIOS} isAppView={isAppView} ref={ProductModalRef}>
          <ModalHeader>
            <ModalTitle>
              {headerText}
              <span>&nbsp;(필수)</span>
            </ModalTitle>
            <button className='btn_close' onClick={closeModal}>
              <img src={`${imgURL}/icon_close.png`} alt='닫기' />
            </button>
          </ModalHeader>
          <ModalBody className='body'>
            <div className='select_wrap'>
              <SelectBox
                show={isShowOptions}
                onClick={() => {
                  setShowOptions((prev) => !prev)
                  setIsShowSecondOptions(false)
                  // if (!isShowOptions) {

                  //   setSelectOption([]);
                  // }
                }}
              >
                <LabelWrap show={isShowOptions}>
                  <Label>{selectOptionTitle}</Label>
                  {isShowOptions ? (
                    <img src={`${imgURL}/icon_arrow_up.png`} alt='옵션 닫기' />
                  ) : (
                    <img src={`${imgURL}/icon_arrow_down.png`} alt='옵션 열기' />
                  )}
                </LabelWrap>
                <SelectOptions show={isShowOptions}>
                  {optionItem.map((el: any) => {
                    if (el.stockCnt !== 0 && !el.forcedSoldOut) {
                      return (
                        <Option
                          key={el.optionNo}
                          onClick={() => {
                            if (selectOption.length === 0) {
                              setSelectOptionTitle(el.value)
                              setSelectOption([el])

                              setCheckChange((prev) => !prev)
                            } else {
                              if (selectOption[0].children) {
                                setSelectOptionTitle(el.value)
                                setSelectOption([el])
                                setCheckChange((prev) => !prev)
                              }
                              const array: any = []
                              for (let i = 0; i < productArray.length; i++) {
                                if (productArray[i].optionNo === el.optionNo) {
                                  alert('동일한 옵션이 선택되어 있습니다.')
                                  return
                                } else if (productArray[i].optionNo !== el.optionNo) {
                                  array.push(el)
                                  const obj = {
                                    productNo: selectProductNo,
                                    optionNo: el.optionNo,
                                    orderCnt: 1,
                                    channelType: null,
                                    cartNo: null,
                                  }

                                  setProductArray((prev: any) => [...prev, obj])
                                }
                              }
                              const uniqueSet = new Set(array)
                              const uniqueArray = Array.from(uniqueSet)

                              setSelectOption((prev: any) => [...prev, ...uniqueArray])
                              setSelectOptionTitle(el.value)
                              if (array.length !== 0) {
                                setSelectCopy((prev: any) => [...prev, ...uniqueArray])
                              }
                              setCheckChange((prev) => !prev)
                            }
                          }}
                        >
                          <p>{`${el.value} ${
                            Number(el?.addPrice) < 0
                              ? `(${el?.addPrice})`
                              : Number(el?.addPrice) === 0 || !el?.addPrice
                              ? ''
                              : `(+${el?.addPrice}원)`
                          }`}</p>
                          <p className='amount'>{`${
                            el.stockCnt && !memberGroupCheck ? `${el.stockCnt}개 남음` : ''
                          }`}</p>
                        </Option>
                      )
                    } else {
                      return (
                        <Option key={el.optionNo}>
                          <p
                            className='soldout'
                            onClick={() => {
                              alert('품절입니다')
                            }}
                          >
                            {el.value}(품절)
                          </p>
                          {!memberGroupCheck && (
                            <div
                              className='restock_notification'
                              onClick={() => {
                                if (hasAccessToken) {
                                  const confirmed = window.confirm('재입고 알림을 신청하시겠습니까?')
                                  if (confirmed) {
                                    postRestock([el.optionNo], userData?.nickname || '', userData?.mobileNo || '')
                                      .then((res) => {
                                        setIsToast(true)
                                        setToastMessage('재입고 알람 신청이 완료되었습니다.')
                                        setToastBtnMessage('바로가기')
                                        setToastEvent(() => () => {
                                          if (isAppView) {
                                            RNPostMessage(AFWebLinkType.moveToLink, {
                                              url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/cart`,
                                            })
                                          } else {
                                            navigate(`/cart`)
                                          }
                                        })
                                      })
                                      .catch((err) => {
                                        setIsToast(true)
                                        setToastMessage('이미 재입고 알람을 신청하셨습니다.')
                                      })
                                  }
                                } else {
                                  setIsToast(true)
                                  setToastMessage('로그인이 필요한 서비스입니다.')
                                  setToastBtnMessage('바로가기')
                                  setToastEvent(() => () => {
                                    const app = getParsedSessionStorageItem('app')
                                    if (app) {
                                      RNPostMessage(AFWebLinkType.onSignInInducement)
                                    } else {
                                      setIsLogin(true)
                                    }

                                    setIsModal(false)
                                  })
                                }
                              }}
                            >
                              <p>재입고 알림 받기</p>
                              <img src='/images/icon_noti.png' alt='재입고 알림' />
                            </div>
                          )}
                        </Option>
                      )
                    }
                  })}
                </SelectOptions>
              </SelectBox>
              {selectOption[0]?.children ? (
                <SelectBox
                  show={isShowSecondOptions}
                  onClick={() => {
                    setIsShowSecondOptions((prev) => !prev)
                    setShowOptions(false)
                  }}
                >
                  <LabelWrap show={isShowSecondOptions}>
                    <Label>{selectSecondOptionTitle}</Label>
                    {isShowSecondOptions ? (
                      <img src={`${imgURL}/icon_arrow_up.png`} alt='옵션 닫기' />
                    ) : (
                      <img src={`${imgURL}/icon_arrow_down.png`} alt='옵션 열기' />
                    )}
                  </LabelWrap>
                  <SelectOptions show={isShowSecondOptions}>
                    {selectOption[0]?.children?.map((el: any) => {
                      if (el.stockCnt !== 0 && !el.forcedSoldOut) {
                        return (
                          <Option
                            key={el.optionNo}
                            onClick={() => {
                              if (selectSecondOption.length === 0) {
                                setSelectSecondOptionTitle(el.value)
                                setSelectSecondOption([el])
                                setCheckChange((prev) => !prev)
                                // setSelectSecondOptionTitle('옵션을 선택해주세요');
                              } else {
                                if (selectSecondOption[0].children) {
                                  setSelectSecondOptionTitle(el.value)
                                  setSelectSecondOption([el])
                                  // setSelectOption([]);
                                  // setSelectOptionTitle('옵션을 선택해주세요');
                                  setCheckChange((prev) => !prev)
                                  // setSelectSecondOptionTitle('옵션을 선택해주세요');
                                }
                                const array: any = []
                                for (let i = 0; i < productArray.length; i++) {
                                  if (Number(productArray[i].optionNo) === Number(el.optionNo)) {
                                    alert('동일한 옵션이 선택되어 있습니다.')
                                    return
                                  } else {
                                    setSelectSecondOptionTitle(el.value)
                                    array.push(el)
                                  }
                                }
                                const uniqueSet = new Set(array)
                                const uniqueArray = Array.from(uniqueSet)
                                setSelectSecondOption((prev: any) => [...prev, ...uniqueArray])

                                //@ts-ignore
                                if (!selectSecondOption[0].children) {
                                  setSelectOption([])
                                  setSelectOptionTitle(optionItem[0]?.label)
                                  setSelectSecondOptionTitle(selectOption[0]?.children[0]?.label)
                                }

                                //@ts-ignore

                                // setSelectOption([]);
                                // setSelectOptionTitle(optionItem[0]?.label);
                                // setSelectSecondOptionTitle(
                                //   selectOption[0]?.children[0]?.label
                                // );

                                setCheckChange((prev) => !prev)
                              }
                              // else {
                              //
                              // }
                            }}
                          >
                            <p>{`${el.value} ${
                              Number(el?.addPrice) < 0
                                ? `(${el?.addPrice})`
                                : Number(el?.addPrice) === 0 || !el?.addPrice
                                ? ''
                                : `(+${el?.addPrice})원`
                            }`}</p>
                            <p
                              className='amount'
                              style={{
                                color: 'var(--colGray76)',
                                fontWeight: '500',
                                fontSize: '14px',
                              }}
                            >{`${el.stockCnt && !memberGroupCheck ? `${el.stockCnt}개 남음` : ''}`}</p>
                          </Option>
                        )
                      } else {
                        return (
                          <Option key={el.optionNo}>
                            <p
                              className='soldout'
                              onClick={() => {
                                alert('품절입니다')
                              }}
                            >
                              {el.value}(품절)
                            </p>
                            {!memberGroupCheck && (
                              <div
                                className='restock_notification'
                                onClick={() => {
                                  if (hasAccessToken) {
                                    const confirmed = window.confirm('재입고 알림을 신청하시겠습니까?')
                                    if (confirmed) {
                                      postRestock([el.optionNo], userData?.nickname || '', userData?.mobileNo || '')
                                        .then((res) => {
                                          setIsToast(true)
                                          setToastMessage('재입고 알람 신청이 완료되었습니다.')
                                          setToastBtnMessage('바로가기')
                                          setToastEvent(() => () => {
                                            if (isAppView) {
                                              RNPostMessage(AFWebLinkType.moveToLink, {
                                                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/cart`,
                                              })
                                            } else {
                                              navigate('/cart')
                                            }
                                          })
                                        })
                                        .catch((err) => {
                                          setIsToast(true)
                                          setToastMessage('이미 재입고 알람을 신청하셨습니다.')
                                        })
                                    }
                                  } else {
                                    setIsToast(true)
                                    setToastMessage('로그인이 필요한 서비스입니다.')
                                    setToastBtnMessage('바로가기')
                                    setToastEvent(() => () => {
                                      const app = getParsedSessionStorageItem('app')
                                      if (app) {
                                        RNPostMessage(AFWebLinkType.onSignInInducement)
                                      } else {
                                        setIsLogin(true)
                                      }

                                      setIsModal(false)
                                    })
                                  }
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: '13px',
                                    lineHeight: '16px',
                                    color: colorObj.colPointBlue,
                                    fontWeight: 500,
                                  }}
                                >
                                  재입고 알림 받기
                                </p>
                                <img src='/images/icon_noti.png' alt='' />
                              </div>
                            )}
                          </Option>
                        )
                      }
                    })}
                  </SelectOptions>
                </SelectBox>
              ) : null}
              {selectSecondOption[0]?.children ? (
                <SelectBox
                  show={isShowThirdOptions}
                  onClick={() => {
                    setIsShowThirdOptions((prev) => !prev)
                    setShowOptions(false)
                  }}
                >
                  <LabelWrap show={isShowThirdOptions}>
                    <Label>{selectThirdOptionTitle}</Label>
                    {isShowThirdOptions ? (
                      <img src={`${imgURL}/icon_arrow_up.png`} alt='옵션 닫기' />
                    ) : (
                      <img src={`${imgURL}/icon_arrow_down.png`} alt='옵션 열기' />
                    )}
                  </LabelWrap>
                  <SelectOptions show={isShowThirdOptions}>
                    {selectSecondOption[0]?.children?.map((el: any) => {
                      if (el.stockCnt !== 0 && !el.forcedSoldOut) {
                        return (
                          <Option
                            key={el.optionNo}
                            onClick={() => {
                              if (selectThirdOption.length === 0) {
                                setSelectSecondOptionTitle(el.value)
                                setSelectThirdOption([el])
                                setSelectSecondOption([])
                                setSelectOption([])
                                setCheckChange((prev) => !prev)
                                setSelectOptionTitle(optionItem[0]?.label)
                                setSelectSecondOptionTitle(selectOption[0]?.children[0]?.label)
                                setSelectThirdOptionTitle(selectSecondOption[0]?.children[0]?.label)
                              } else {
                                const array: any = []
                                for (let i = 0; i < productArray.length; i++) {
                                  if (Number(productArray[i].optionNo) === Number(el.optionNo)) {
                                    alert('동일한 옵션이 선택되어 있습니다.')
                                    return
                                  } else {
                                    setSelectThirdOptionTitle(el.value)
                                    array.push(el)
                                  }
                                }
                                const uniqueSet = new Set(array)
                                const uniqueArray = Array.from(uniqueSet)
                                setSelectThirdOption((prev: any) => [...prev, ...uniqueArray])

                                setSelectOption([])
                                setSelectSecondOption([])
                                setSelectOptionTitle(optionItem[0]?.label)
                                setSelectSecondOptionTitle(selectOption[0]?.children[0]?.label)
                                setSelectThirdOptionTitle(selectSecondOption[0]?.children[0]?.label)

                                setCheckChange((prev) => !prev)
                              }
                              // else {
                              //
                              // }
                            }}
                          >
                            <p>{`${el.value} ${
                              Number(el?.addPrice) < 0
                                ? `(${el?.addPrice}원)`
                                : Number(el?.addPrice) === 0 || !el?.addPrice
                                ? ''
                                : `(+${el?.addPrice}원)`
                            }`}</p>
                            <p
                              className='amount'
                              style={{
                                color: 'var(--colGray76)',
                                fontWeight: '500',
                                fontSize: '14px',
                              }}
                            >{`${el.stockCnt && !memberGroupCheck ? `${el.stockCnt}개 남음` : ''}`}</p>
                          </Option>
                        )
                      } else {
                        return (
                          <Option key={el.optionNo}>
                            <p
                              className='soldout'
                              onClick={() => {
                                alert('품절입니다')
                              }}
                            >
                              {el.value}(품절)
                            </p>
                            {!memberGroupCheck && (
                              <div
                                className='restock_notification'
                                onClick={() => {
                                  if (hasAccessToken) {
                                    const confirmed = window.confirm('재입고 알림을 신청하시겠습니까?')
                                    if (confirmed) {
                                      postRestock([el.optionNo], userData?.nickname || '', userData?.mobileNo || '')
                                        .then((res) => {
                                          setIsToast(true)
                                          setToastMessage('재입고 알람 신청이 완료되었습니다.')
                                          setToastBtnMessage('바로가기')
                                          setToastEvent(() => () => {
                                            if (isAppView) {
                                              RNPostMessage(AFWebLinkType.moveToLink, {
                                                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/cart`,
                                              })
                                            } else {
                                              navigate('/cart')
                                            }
                                          })
                                        })
                                        .catch((err) => {
                                          setIsToast(true)
                                          setToastMessage('이미 재입고 알람을 신청하셨습니다.')
                                        })
                                    }
                                  } else {
                                    setIsToast(true)
                                    setToastMessage('로그인이 필요한 서비스입니다.')
                                    setToastBtnMessage('바로가기')
                                    setToastEvent(() => () => {
                                      const app = getParsedSessionStorageItem('app')
                                      if (app) {
                                        RNPostMessage(AFWebLinkType.onSignInInducement)
                                      } else {
                                        setIsLogin(true)
                                      }

                                      setIsModal(false)
                                    })
                                  }
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: '13px',
                                    lineHeight: '16px',
                                    color: colorObj.colPointBlue,
                                    fontWeight: 500,
                                  }}
                                >
                                  재입고 알림 받기
                                </p>
                                <img src='/images/icon_noti.png' alt='' />
                              </div>
                            )}
                          </Option>
                        )
                      }
                    })}
                  </SelectOptions>
                </SelectBox>
              ) : null}
              {selectThirdOption[0]?.children ? (
                <SelectBox
                  show={isShowThirdOptions}
                  onClick={() => {
                    setIsShowThirdOptions((prev) => !prev)
                    setShowOptions(false)
                  }}
                >
                  <LabelWrap show={isShowThirdOptions}>
                    <Label>{selectThirdOptionTitle}</Label>
                    {isShowThirdOptions ? (
                      <img src={`${imgURL}/icon_arrow_up.png`} alt='옵션 닫기' />
                    ) : (
                      <img src={`${imgURL}/icon_arrow_down.png`} alt='옵션 열기' />
                    )}
                  </LabelWrap>
                  <SelectOptions show={isShowThirdOptions}>
                    {selectSecondOption[0]?.children?.map((el: any) => {
                      if (el.stockCnt !== 0 && !el.forcedSoldOut) {
                        return (
                          <Option
                            key={el.optionNo}
                            onClick={() => {
                              if (selectFourOption.length === 0) {
                                setSelectSecondOptionTitle(el.value)
                                setSelectFourOption([el])
                                setSelectSecondOption([])
                                setSelectOption([])
                                setCheckChange((prev) => !prev)
                                setSelectOptionTitle(optionItem[0]?.label)
                                setSelectSecondOptionTitle(selectOption[0]?.children[0]?.label)
                                setSelectThirdOptionTitle(selectSecondOption[0]?.children[0]?.label)
                                setSelectFourOptionTitle(selectThirdOption[0]?.children[0]?.label)
                              } else {
                                const array: any = []
                                for (let i = 0; i < productArray.length; i++) {
                                  if (Number(productArray[i].optionNo) === Number(el.optionNo)) {
                                    alert('동일한 옵션이 선택되어 있습니다.')
                                    return
                                  } else {
                                    setSelectFourOptionTitle(el.value)
                                    array.push(el)
                                  }
                                }
                                const uniqueSet = new Set(array)
                                const uniqueArray = Array.from(uniqueSet)
                                setSelectFourOption((prev: any) => [...prev, ...uniqueArray])

                                if (!selectSecondOption[0]?.children) {
                                  setSelectOption([])
                                  setSelectSecondOption([])
                                  setSelectThirdOption([])
                                  setSelectOptionTitle(optionItem[0]?.label)
                                  setSelectSecondOptionTitle(selectOption[0]?.children[0]?.label)
                                  setSelectThirdOptionTitle(selectSecondOption[0]?.children[0]?.label)
                                  setSelectFourOptionTitle(selectThirdOption[0]?.children[0]?.label)
                                }

                                setCheckChange((prev) => !prev)
                              }
                              // else {
                              //
                              // }
                            }}
                          >
                            <p>{`${el.value} ${
                              Number(el?.addPrice) < 0
                                ? `(${el?.addPrice}원)`
                                : Number(el?.addPrice) === 0 || !el?.addPrice
                                ? ''
                                : `(+${el?.addPrice}원)`
                            }`}</p>
                            <p
                              className='amount'
                              style={{
                                color: 'var(--colGray76)',
                                fontWeight: '500',
                                fontSize: '14px',
                              }}
                            >{`${el.stockCnt && !memberGroupCheck ? `${el.stockCnt}개 남음` : ''}`}</p>
                          </Option>
                        )
                      } else {
                        return (
                          <Option key={el.optionNo}>
                            <p
                              className='soldout'
                              onClick={() => {
                                alert('품절입니다')
                              }}
                            >
                              {el.value}(품절)
                            </p>
                            {!memberGroupCheck && (
                              <div
                                className='restock_notification'
                                onClick={() => {
                                  if (hasAccessToken) {
                                    const confirmed = window.confirm('재입고 알림을 신청하시겠습니까?')
                                    if (confirmed) {
                                      postRestock([el.optionNo], userData?.nickname || '', userData?.mobileNo || '')
                                        .then((res) => {
                                          setIsToast(true)
                                          setToastMessage('재입고 알람 신청이 완료되었습니다.')
                                          setToastBtnMessage('바로가기')
                                          setToastEvent(() => () => {
                                            if (isAppView) {
                                              RNPostMessage(AFWebLinkType.moveToLink, {
                                                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/cart`,
                                              })
                                            } else {
                                              navigate('/cart')
                                            }
                                          })
                                        })
                                        .catch((err) => {
                                          setIsToast(true)
                                          setToastMessage('이미 재입고 알람을 신청하셨습니다.')
                                        })
                                    }
                                  } else {
                                    setIsToast(true)
                                    setToastMessage('로그인이 필요한 서비스입니다.')
                                    setToastBtnMessage('바로가기')
                                    setToastEvent(() => () => {
                                      const app = getParsedSessionStorageItem('app')
                                      if (app) {
                                        RNPostMessage(AFWebLinkType.onSignInInducement)
                                      } else {
                                        setIsLogin(true)
                                      }

                                      setIsModal(false)
                                    })
                                  }
                                }}
                              >
                                <p
                                  style={{
                                    fontSize: '13px',
                                    lineHeight: '16px',
                                    color: colorObj.colPointBlue,
                                    fontWeight: 500,
                                  }}
                                >
                                  재입고 알림 받기
                                </p>
                                <img src='/images/icon_noti.png' alt='' />
                              </div>
                            )}
                          </Option>
                        )
                      }
                    })}
                  </SelectOptions>
                </SelectBox>
              ) : null}
              {selectFourOption[0]?.children ? (
                <SelectBox
                  show={isShowThirdOptions}
                  onClick={() => {
                    setIsShowThirdOptions((prev) => !prev)
                    setShowOptions(false)
                  }}
                >
                  <LabelWrap show={isShowThirdOptions}>
                    <Label>{selectThirdOptionTitle}</Label>
                    {isShowThirdOptions ? (
                      <img src={`${imgURL}/icon_arrow_up.png`} alt='옵션 닫기' />
                    ) : (
                      <img src={`${imgURL}/icon_arrow_down.png`} alt='옵션 열기' />
                    )}
                  </LabelWrap>
                  <SelectOptions show={isShowThirdOptions}>
                    {selectFourOption[0]?.children?.map((el: any) => {
                      if (el.stockCnt !== 0 && !el.forcedSoldOut) {
                        return (
                          <Option
                            key={el.optionNo}
                            onClick={() => {
                              if (selectFourOption.length === 0) {
                                setSelectSecondOptionTitle(el.value)
                                setSelectFiveOption([el])
                                setSelectSecondOption([])
                                setSelectOption([])
                                setCheckChange((prev) => !prev)
                                setSelectOptionTitle(optionItem[0]?.label)
                                setSelectSecondOptionTitle(selectOption[0]?.children[0]?.label)
                                setSelectThirdOptionTitle(selectSecondOption[0]?.children[0]?.label)
                                setSelectFourOptionTitle(selectThirdOption[0]?.children[0]?.label)
                                setSelectFiveOptionTitle(selectFourOption[0]?.children[0]?.label)
                              } else {
                                const array: any = []
                                for (let i = 0; i < productArray.length; i++) {
                                  if (Number(productArray[i].optionNo) === Number(el.optionNo)) {
                                    alert('동일한 옵션이 선택되어 있습니다.')
                                    return
                                  } else {
                                    setSelectFourOptionTitle(el.value)
                                    array.push(el)
                                  }
                                }
                                const uniqueSet = new Set(array)
                                const uniqueArray = Array.from(uniqueSet)
                                setSelectFiveOption((prev: any) => [...prev, ...uniqueArray])

                                if (!selectSecondOption[0]?.children) {
                                  setSelectOption([])
                                  setSelectSecondOption([])
                                  setSelectThirdOption([])
                                  setSelectOptionTitle(optionItem[0]?.label)
                                  setSelectSecondOptionTitle(selectOption[0]?.children[0]?.label)
                                  setSelectThirdOptionTitle(selectSecondOption[0]?.children[0]?.label)
                                  setSelectFourOptionTitle(selectThirdOption[0]?.children[0]?.label)
                                  setSelectFiveOptionTitle(selectFourOption[0]?.children[0]?.label)
                                }

                                setCheckChange((prev) => !prev)
                              }
                              // else {
                              //
                              // }
                            }}
                          >
                            <p>{`${el.value} ${
                              Number(el?.addPrice) < 0
                                ? `(${el?.addPrice}원)`
                                : Number(el?.addPrice) === 0 || !el?.addPrice
                                ? ''
                                : `(+${el?.addPrice}원)`
                            }`}</p>
                            <p className='amount'>{`${
                              el.stockCnt && !memberGroupCheck ? `${el.stockCnt}개 남음` : ''
                            }`}</p>
                          </Option>
                        )
                      } else {
                        return (
                          <Option key={el.optionNo}>
                            <p
                              className='soldout'
                              onClick={() => {
                                alert('품절입니다')
                              }}
                            >
                              {el.value}(품절)
                            </p>
                            {!memberGroupCheck && (
                              <div
                                className='restock_notification'
                                onClick={() => {
                                  if (hasAccessToken) {
                                    const confirmed = window.confirm('재입고 알림을 신청하시겠습니까?')
                                    if (confirmed) {
                                      postRestock([el.optionNo], userData?.nickname || '', userData?.mobileNo || '')
                                        .then((res) => {
                                          setIsToast(true)
                                          setToastMessage('재입고 알람 신청이 완료되었습니다.')
                                          setToastBtnMessage('바로가기')
                                          setToastEvent(() => () => {
                                            if (isAppView) {
                                              RNPostMessage(AFWebLinkType.moveToLink, {
                                                url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/cart`,
                                              })
                                            } else {
                                              navigate('/cart')
                                            }
                                          })
                                        })
                                        .catch((err) => {
                                          setIsToast(true)
                                          setToastMessage('이미 재입고 알람을 신청하셨습니다.')
                                        })
                                    }
                                  } else {
                                    setIsToast(true)
                                    setToastMessage('로그인이 필요한 서비스입니다.')
                                    setToastBtnMessage('바로가기')
                                    setToastEvent(() => () => {
                                      const app = getParsedSessionStorageItem('app')
                                      if (app) {
                                        RNPostMessage(AFWebLinkType.onSignInInducement)
                                      } else {
                                        setIsLogin(true)
                                      }

                                      setIsModal(false)
                                    })
                                  }
                                }}
                              >
                                <p>재입고 알림 받기</p>
                                <img src='/images/icon_noti.png' alt='' />
                              </div>
                            )}
                          </Option>
                        )
                      }
                    })}
                  </SelectOptions>
                </SelectBox>
              ) : null}
              <OptionBoxWrap>
                {!selectOption[0]?.children ? (
                  <OptionBox>
                    {selectOption?.map((el: any, idx: number) => {
                      return (
                        <SelectOption
                          key={el.optionNo}
                          setAllPrice={setAllPrice}
                          el={el}
                          idx={idx}
                          allCount={price}
                          selectOptionTitle={selectOptionTitle}
                          selectOption={selectOption}
                          setSelectOption={setSelectOption}
                          setSelectOptionTitle={setSelectOptionTitle}
                          setAllCount={setPrice}
                          setProductArray={setProductArray}
                          productArray={productArray}
                          selectProductNo={selectProductNo}
                          checkChange={checkChange}
                          floatOption={floatOption}
                        ></SelectOption>
                      )
                    })}
                  </OptionBox>
                ) : null}

                {!selectSecondOption[0]?.children ? (
                  <OptionBox>
                    {selectSecondOption?.map((el: any, idx: number) => {
                      return (
                        <SelectSecondOption
                          selectCopy={selectCopy}
                          key={el.optionNo}
                          el={el}
                          idx={idx}
                          allCount={price}
                          selectOptionTitle={selectOptionTitle}
                          selectSecondOption={selectSecondOption}
                          setSelectFirstOption={setSelectOption}
                          setSelectSecondOption={setSelectSecondOption}
                          setSelectOptionTitle={setSelectOptionTitle}
                          setAllCount={setPrice}
                          setProductArray={setProductArray}
                          productArray={productArray}
                          selectProductNo={selectProductNo}
                          checkChange={checkChange}
                          setSelectCopy={setSelectCopy}
                          floatOption={floatOption}
                        ></SelectSecondOption>
                      )
                    })}
                  </OptionBox>
                ) : null}

                {!selectThirdOption[0]?.children ? (
                  <OptionBox>
                    {selectThirdOption?.map((el: any, idx: number) => {
                      return (
                        <SelectThirdOption
                          selectCopy={selectCopy}
                          key={el.optionNo}
                          el={el}
                          idx={idx}
                          allCount={price}
                          selectOptionTitle={selectOptionTitle}
                          selectSecondOption={selectThirdOption}
                          setSelectFirstOption={setSelectOption}
                          setSelectSecondOption={setSelectThirdOption}
                          setSelectOptionTitle={setSelectOptionTitle}
                          setAllCount={setPrice}
                          setProductArray={setProductArray}
                          productArray={productArray}
                          selectProductNo={selectProductNo}
                          checkChange={checkChange}
                          setSelectCopy={setSelectCopy}
                          floatOption={floatOption}
                        ></SelectThirdOption>
                      )
                    })}
                  </OptionBox>
                ) : null}

                {!selectFourOption[0]?.children ? (
                  <OptionBox>
                    {selectFourOption?.map((el: any, idx: number) => {
                      return (
                        <SelectThirdOption
                          selectCopy={selectCopy}
                          key={el.optionNo}
                          el={el}
                          idx={idx}
                          allCount={price}
                          selectOptionTitle={selectOptionTitle}
                          selectSecondOption={selectFourOption}
                          setSelectFirstOption={setSelectOption}
                          setSelectSecondOption={setSelectThirdOption}
                          setSelectOptionTitle={setSelectOptionTitle}
                          setAllCount={setPrice}
                          setProductArray={setProductArray}
                          productArray={productArray}
                          selectProductNo={selectProductNo}
                          checkChange={checkChange}
                          setSelectCopy={setSelectCopy}
                          floatOption={floatOption}
                        ></SelectThirdOption>
                      )
                    })}
                  </OptionBox>
                ) : null}
                {!selectFiveOption[0]?.children ? (
                  <OptionBox>
                    {selectFiveOption?.map((el: any, idx: number) => {
                      return (
                        <SelectThirdOption
                          selectCopy={selectCopy}
                          key={el.optionNo}
                          el={el}
                          idx={idx}
                          allCount={price}
                          selectOptionTitle={selectOptionTitle}
                          selectSecondOption={selectFiveOption}
                          setSelectFirstOption={setSelectOption}
                          setSelectSecondOption={setSelectThirdOption}
                          setSelectOptionTitle={setSelectOptionTitle}
                          setAllCount={setPrice}
                          setProductArray={setProductArray}
                          productArray={productArray}
                          selectProductNo={selectProductNo}
                          checkChange={checkChange}
                          setSelectCopy={setSelectCopy}
                          floatOption={floatOption}
                        ></SelectThirdOption>
                      )
                    })}
                  </OptionBox>
                ) : null}
              </OptionBoxWrap>
            </div>
            {allPrice ? (
              <PriceWrap>
                <p className='total_title'>총 상품금액</p>
                <p className='total_price'>{plusComma(allPrice)}원</p>
              </PriceWrap>
            ) : null}
          </ModalBody>
          <div>
            <ModalFooter className='footer'>
              <CartBtnWrap>
                <CartBtnLeft
                  onClick={() => {
                    if (productArray.length !== 0) {
                      if (hasAccessToken) {
                        if (wonShop.length !== 0 && firstPurchase) {
                          alert('100원샵 이용가능한 회원이 아닙니다.')
                          return
                        } else {
                          getCart().then((res) => {
                            let con = 0
                            res.data.deliveryGroups.map((el: any) => {
                              el.orderProducts.map((element: any) => {
                                con += element.orderProductOptions.length
                              })
                            })

                            const pixelContents: { name: string; quantity: number }[] = []
                            const pixelContent_ids: number[] = []
                            selectOption.forEach((option: any) => {
                              productArray.forEach((el: any) => {
                                if (el.optionNo === option.optionNo) {
                                  pixelContents.push({ name: option.value, quantity: el.orderCnt })
                                  pixelContent_ids.push(Number(option.optionManagementCd))
                                }
                              })
                            })
                            if (location.pathname.includes('product')) {
                              if (prevItems && prevItems?.length !== 0) {
                                addToCart(
                                  pixelContent_ids,
                                  pixelContents as [{ name: string; quantity: number }],
                                  `${prevItems[0]?.item_category}/${prevItems[0]?.item_category2}/${prevItems[0]?.item_category3}`,
                                  allPrice
                                )
                              } else {
                                addToCart(
                                  pixelContent_ids,
                                  pixelContents as [{ name: string; quantity: number }],
                                  `${listItem?.categories[0]?.categories[0]?.label}/${listItem?.categories[0]?.categories[1]?.label}/${listItem?.categories[0]?.categories[2]?.label}`,
                                  allPrice
                                )
                              }
                            } else if (location.pathname.includes('exhibitiondetail')) {
                              addToCart(
                                pixelContent_ids,
                                pixelContents as [{ name: string; quantity: number }],
                                `${exhibitionCategory?.depth1Label}/${
                                  exhibitionCategory?.depth2Label ? exhibitionCategory?.depth2Label : ''
                                }/${exhibitionCategory?.depth3Label ? exhibitionCategory?.depth3Label : ''}`,
                                allPrice
                              )
                            } else {
                              addToCart(
                                pixelContent_ids,
                                pixelContents as [{ name: string; quantity: number }],
                                `${filterCategory[0]?.depth1Label}/${filterCategory[0]?.depth2Label}/${filterCategory[0]?.depth3Label},`,
                                allPrice
                              )
                            }

                            postCart(productArray)
                              .then((res) => {
                                const cleanPath = location.pathname.replace(/\/$/, '')
                                if (location.pathname.includes('product')) {
                                  //상품상세
                                  const gtmarray: any = []
                                  const price: number = 0
                                  let orderCnt: number = 0
                                  productArray.map((el: any) => {
                                    if (prevItems && prevItems.length !== 0) {
                                      let optionValue
                                      for (let j = 0; j < floatOption.length; j++) {
                                        if (el.optionNo === floatOption[j].optionNo) {
                                          optionValue = floatOption[j].value
                                        }
                                      }

                                      const obj = {
                                        item_id: String(product?.baseInfo?.productNo),
                                        item_name: product?.baseInfo?.productName,
                                        affiliation: '어바웃피싱',
                                        item_list_price: product?.price?.salePrice,
                                        item_selling_price:
                                          product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                        price: product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                        quantity: el.orderCnt,
                                        item_total_discount: product?.price?.immediateDiscountAmt,
                                        discount: 0,
                                        index: '',
                                        item_brand: product?.brand?.name,
                                        item_category: prevItems[0]?.item_category,
                                        item_category2: prevItems[0]?.item_category2,
                                        item_category3: prevItems[0]?.item_category3,
                                        item_variant: optionValue,
                                        item_list_id: String(prevItems[0]?.item_list_id),
                                        item_list_name: prevItems[0]?.item_list_name,

                                        promotion_id: String(prevItems[0].promotion_id),
                                        promotion_name: prevItems[0].promotion_name,
                                      }
                                      gtmarray.push(obj)

                                      const itemList = getParsedLocalStorageItem('cartlist')
                                      const array = [...itemList]
                                      let bol = false
                                      if (array.length === 0) {
                                        bol = false
                                      } else {
                                        array.map((el) => {
                                          if (Number(el.product) === Number(obj.item_id)) {
                                            bol = true
                                          } else {
                                            bol = false
                                          }
                                        })
                                      }
                                      if (bol) {
                                        return
                                      } else {
                                        array.push({
                                          promotion_id: obj.promotion_id ? obj.promotion_id : '',
                                          promotion_name: obj.promotion_name ? obj.promotion_name : '',
                                          product: obj.item_id,
                                          item_list_id: obj.item_list_id,
                                          item_list_name: obj.item_list_name,
                                        })
                                      }

                                      window.localStorage.setItem('cartlist', JSON.stringify(array))
                                    } else {
                                      let optionValue
                                      for (let j = 0; j < floatOption.length; j++) {
                                        if (el.optionNo === floatOption[j].optionNo) {
                                          optionValue = floatOption[j].value
                                        }
                                      }
                                      const obj = {
                                        item_id: String(product?.baseInfo?.productNo),
                                        item_name: product?.baseInfo?.productName,
                                        affiliation: '어바웃피싱',
                                        item_list_price: product?.price?.salePrice,
                                        item_selling_price:
                                          product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                        price: product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                        quantity: el.orderCnt,
                                        item_total_discount: product?.price?.immediateDiscountAmt,
                                        discount: 0,
                                        index: '',
                                        item_brand: product?.brand?.name,
                                        item_category: listItem?.categories[0]?.categories[0]?.label,
                                        item_category2: listItem?.categories[0]?.categories[1]?.label,
                                        item_category3: listItem?.categories[0]?.categories[2]?.label,
                                        item_variant: optionValue,
                                        item_list_id: String(listItem?.categories[0]?.categories[1]?.categoryNo),
                                        item_list_name: listItem?.categories[0]?.categories[1]?.label,
                                      }

                                      gtmarray.push(obj)
                                      const itemList = getParsedLocalStorageItem('cartlist')
                                      const array = [...itemList]
                                      const listArray: any = []
                                      let bol = false
                                      if (array.length === 0) {
                                        bol = false
                                      } else {
                                        array.map((el) => {
                                          if (Number(el.product) === Number(obj.item_id)) {
                                            bol = true
                                          } else {
                                            bol = false
                                          }
                                        })
                                      }
                                      if (bol) {
                                        return
                                      } else {
                                        listArray.push({
                                          promotion_id: '',
                                          promotion_name: '',
                                          product: obj.item_id,
                                          item_list_id: obj.item_list_id,
                                          item_list_name: obj.item_list_name,
                                        })

                                        window.localStorage.setItem('cartlist', JSON.stringify(listArray))
                                      }
                                    }
                                  })

                                  for (let i = 0; i < productArray.length; i++) {
                                    orderCnt += Number(productArray[i].orderCnt)
                                  }
                                  //@ts-ignore
                                  NA_CART(selectItem?.baseInfo?.productNo, selectItem?.baseInfo?.productName, orderCnt)
                                  const addCartItem: DataLayerArgs = {
                                    dataLayer: {
                                      event: 'add_to_cart', // ecommerce 이벤트 중 상품보기 단계
                                      ecommerce: {
                                        currency: 'KRW',
                                        value: allPrice,
                                        payback: product?.price?.accumulationAmtWhenBuyConfirm,
                                        reserve_discount: 0,
                                        items: gtmarray,
                                      },
                                    },
                                  }
                                  if (isAppView) {
                                    sendSetAppsflyerEvent({
                                      eventName: 'add_to_cart',
                                      eventType: {
                                        currency: 'KRW',
                                        value: allPrice,
                                        items: gtmarray,
                                        payback: product?.price?.accumulationAmtWhenBuyConfirm,
                                        reserve_discount: 0,
                                      },
                                    })
                                  } else {
                                    TagManager.dataLayer(addCartItem)
                                  }
                                } else if (location.pathname.includes('exhibitiondetail')) {
                                  //기획전
                                  const gtmarray: any = []
                                  let price: number = 0
                                  let orderCnt: number = 0
                                  productArray.map((el: any) => {
                                    let optionValue
                                    for (let j = 0; j < floatOption.length; j++) {
                                      if (el.optionNo === floatOption[j].optionNo) {
                                        optionValue = floatOption[j].value
                                      }
                                    }
                                    const obj = {
                                      item_id: String(selectItem?.productNo),
                                      item_name: selectItem?.productName,
                                      affiliation: '어바웃피싱',
                                      item_list_price: selectItem?.salePrice,
                                      item_selling_price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                      price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                      quantity: el.orderCnt,
                                      item_total_discount: selectItem?.immediateDiscountAmt,
                                      discount: 0,
                                      index: idx,
                                      item_brand: selectItem?.brandName,
                                      item_category: exhibitionCategory?.depth1Label,
                                      item_category2: exhibitionCategory?.depth2Label,
                                      item_category3: exhibitionCategory?.depth3Label,
                                      item_variant: optionValue,
                                      promotion_id: String(promotion_id),
                                      promotion_name: promotion_name,
                                    }
                                    gtmarray.push(obj)
                                    const itemList = getParsedLocalStorageItem('cartlist')
                                    const array = [...itemList]
                                    let bol = false
                                    if (array.length === 0) {
                                      bol = false
                                    } else {
                                      array.map((el) => {
                                        if (Number(el.product) === Number(obj.item_id)) {
                                          bol = true
                                        } else {
                                          bol = false
                                        }
                                      })
                                    }
                                    if (bol) {
                                      return
                                    } else {
                                      array.push({
                                        promotion_id: obj.promotion_id,
                                        promotion_name: obj.promotion_name,
                                        product: obj.item_id,
                                        item_list_id: '',
                                        item_list_name: '',
                                      })
                                    }

                                    window.localStorage.setItem('cartlist', JSON.stringify(array))
                                  })
                                  for (let i = 0; i < gtmarray.length; i++) {
                                    price += gtmarray[i].price * gtmarray[i].quantity
                                    orderCnt += gtmarray[i].quantity
                                  }
                                  //@ts-ignore
                                  NA_CART(String(selectItem?.productNo), selectItem?.productName, orderCnt)

                                  const addCartItem: DataLayerArgs = {
                                    dataLayer: {
                                      event: 'add_to_cart', // ecommerce 이벤트 중 상품보기 단계
                                      ecommerce: {
                                        currency: 'KRW',
                                        value: allPrice,
                                        items: gtmarray,
                                      },
                                    },
                                  }
                                  if (isAppView) {
                                    sendSetAppsflyerEvent({
                                      eventName: 'add_to_cart',
                                      eventType: {
                                        currency: 'KRW',
                                        value: allPrice,
                                        items: gtmarray,
                                        payback: product?.price?.accumulationAmtWhenBuyConfirm,
                                        reserve_discount: 0,
                                      },
                                    })
                                  } else {
                                    TagManager.dataLayer(addCartItem)
                                  }
                                } else if (cleanPath === '') {
                                  //홈모듈
                                  const gtmarray: any = []
                                  let orderCnt: number = 0
                                  productArray.map((el: any) => {
                                    let optionValue
                                    for (let j = 0; j < floatOption.length; j++) {
                                      if (el.optionNo === floatOption[j].optionNo) {
                                        optionValue = floatOption[j].value
                                      }
                                    }
                                    const obj = {
                                      item_id: String(selectItem?.productNo),
                                      item_name: selectItem?.productName,
                                      affiliation: '어바웃피싱',
                                      item_list_price: selectItem?.salePrice,
                                      item_selling_price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                      price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                      quantity: el.orderCnt,
                                      item_total_discount: selectItem?.immediateDiscountAmt,
                                      discount: 0,
                                      index: idx,
                                      item_brand: selectItem?.brandName,
                                      item_category: filterCategory[0]?.depth1Label,
                                      item_category2: filterCategory[0]?.depth2Label,
                                      item_category3: filterCategory[0]?.depth3Label,
                                      item_variant: optionValue,
                                      item_list_id: String(listId),
                                      item_list_name: listName,
                                    }
                                    gtmarray.push(obj)
                                    const itemList = getParsedLocalStorageItem('cartlist')
                                    const array = [...itemList]
                                    let bol = false
                                    if (array.length === 0) {
                                      bol = false
                                    } else {
                                      array.map((el) => {
                                        if (Number(el.product) === Number(obj.item_id)) {
                                          bol = true
                                        } else {
                                          bol = false
                                        }
                                      })
                                    }
                                    if (!bol) {
                                      array.push({
                                        promotion_id: '',
                                        promotion_name: '',
                                        product: obj.item_id,
                                        item_list_id: obj.item_list_id,
                                        item_list_name: obj.item_list_name,
                                      })
                                    }
                                    window.localStorage.setItem('cartlist', JSON.stringify(array))
                                  })
                                  for (let i = 0; i < productArray.length; i++) {
                                    orderCnt += Number(productArray[i].orderCnt)
                                  }
                                  //@ts-ignore
                                  NA_CART(selectItem?.productNo, selectItem?.productName, orderCnt)
                                  const addCartItem: DataLayerArgs = {
                                    dataLayer: {
                                      event: 'add_to_cart', // ecommerce 이벤트 중 상품보기 단계
                                      ecommerce: {
                                        currency: 'KRW',
                                        value: allPrice,
                                        items: gtmarray,
                                      },
                                    },
                                  }
                                  if (isAppView) {
                                    sendSetAppsflyerEvent({
                                      eventName: 'add_to_cart',
                                      eventType: {
                                        currency: 'KRW',
                                        value: allPrice,
                                        items: gtmarray,
                                      },
                                    })
                                  } else if (!isAppView) {
                                    TagManager.dataLayer(addCartItem)
                                  }
                                } else {
                                  const gtmarray: any = []
                                  let orderCnt: number = 0
                                  productArray.map((el: any) => {
                                    let optionValue
                                    for (let j = 0; j < floatOption.length; j++) {
                                      if (el.optionNo === floatOption[j].optionNo) {
                                        optionValue = floatOption[j].value
                                      }
                                    }
                                    const obj = {
                                      item_id: String(selectItem?.productNo),
                                      item_name: selectItem?.productName,
                                      affiliation: '어바웃피싱',
                                      item_list_price: selectItem?.salePrice,
                                      item_selling_price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                      price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                      quantity: el.orderCnt,
                                      item_total_discount: selectItem?.immediateDiscountAmt,
                                      discount: 0,
                                      index: idx,
                                      item_brand: selectItem?.brandName,
                                      item_category: filterCategory[0]?.depth1Label,
                                      item_category2: filterCategory[0]?.depth2Label,
                                      item_category3: filterCategory[0]?.depth3Label,
                                      item_variant: optionValue,
                                      item_list_id: String(filterCategory[0]?.depth3CategoryNo),
                                      item_list_name: filterCategory[0]?.depth3Label,
                                    }
                                    gtmarray.push(obj)
                                    const itemList = getParsedLocalStorageItem('cartlist')
                                    const array = [...itemList]
                                    let bol = false
                                    if (array.length === 0) {
                                      bol = false
                                    } else {
                                      array.map((el) => {
                                        if (Number(el.product) === Number(obj.item_id)) {
                                          bol = true
                                        } else {
                                          bol = false
                                        }
                                      })
                                    }
                                    if (!bol) {
                                      array.push({
                                        promotion_id: '',
                                        promotion_name: '',
                                        product: obj.item_id,
                                        item_list_id: obj.item_list_id,
                                        item_list_name: obj.item_list_name,
                                      })
                                    }

                                    window.localStorage.setItem('cartlist', JSON.stringify(array))
                                  })

                                  for (let i = 0; i < productArray.length; i++) {
                                    orderCnt += Number(productArray[i].orderCnt)
                                  }

                                  //@ts-ignore
                                  NA_CART(selectItem?.productNo, selectItem?.productName, orderCnt)
                                  const addCartItem: DataLayerArgs = {
                                    dataLayer: {
                                      event: 'add_to_cart', // ecommerce 이벤트 중 상품보기 단계
                                      ecommerce: {
                                        currency: 'KRW',
                                        value: allPrice,
                                        items: gtmarray,
                                      },
                                    },
                                  }
                                  if (isAppView) {
                                    sendSetAppsflyerEvent({
                                      eventName: 'add_to_cart',
                                      eventType: {
                                        currency: 'KRW',
                                        value: allPrice,
                                        items: gtmarray,
                                      },
                                    })
                                  } else if (!isAppView) {
                                    TagManager.dataLayer(addCartItem)
                                  }
                                }
                                const value = window.sessionStorage.getItem('cart')
                                const array: any = productArray
                                //@ts-ignore
                                if (JSON.parse(value) !== null) {
                                  //@ts-ignore
                                  array.push(...JSON.parse(value))
                                }
                                window.sessionStorage.setItem('cart', JSON.stringify(array))

                                closeModal()
                                setIsToast(true)
                                setToastMessage('상품이 장바구니에 담겼습니다.')
                                setToastBtnMessage('바로가기')
                                setToastEvent(() => () => {
                                  if (isAppView) {
                                    RNPostMessage(AFWebLinkType.moveToLink, {
                                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/cart`,
                                    })
                                  } else {
                                    navigate('/cart')
                                  }
                                })
                                setAddCart((prev: boolean) => !prev)
                              })
                              .catch((err) => {
                                const message = err?.response?.data.message
                                console.log(err)
                                alert(message)
                                closeModal()
                              })
                          })
                        }
                      } else {
                        const value = getParsedSessionStorageItem('guestCart')
                        if (
                          cartConfig?.storageMaxQuantity !== undefined &&
                          cartConfig.storageMaxQuantity <= value.length
                        ) {
                          alert(
                            `장바구니에 담을 수 있는 최대 상품 수(${cartConfig.storageMaxQuantity})를 초과하였습니다. 담겨있는 상품 삭제 후 추가하실 수 있습니다.`
                          )
                          return
                        }
                        if (!memberCheck) {
                          const array: any = [...productArray]
                          const plus = [...productArray, ...value]
                          const plusArray: any = [...value]
                          //@ts-ignore

                          plusArray.push(...productArray)

                          const mergeArraysByOptionNo = (arr1: any, arr2: any) => {
                            const combinedArray = [...arr1, ...arr2]

                            return combinedArray.reduce((acc, current) => {
                              const existing = acc.find((item: any) => item.optionNo === current.optionNo)
                              if (existing) {
                                existing.orderCnt += current.orderCnt
                              } else {
                                acc.push({ ...current })
                              }
                              return acc
                            }, [])
                          }
                          setAddCart((prev: boolean) => !prev)

                          // 배열 합치기
                          const mergedData = mergeArraysByOptionNo(array, value)

                          const pixelContents: { name: string; quantity: number }[] = []
                          const pixelContent_ids: number[] = []
                          selectOption.forEach((option: any) => {
                            productArray.forEach((el: any) => {
                              if (el.optionNo === option.optionNo) {
                                pixelContents.push({ name: option.value, quantity: el.orderCnt })
                                pixelContent_ids.push(Number(option.optionManagementCd))
                              }
                            })
                          })
                          if (location.pathname.includes('product')) {
                            if (prevItems && prevItems.length !== 0) {
                              addToCart(
                                pixelContent_ids,
                                pixelContents as [{ name: string; quantity: number }],
                                `${prevItems[0]?.item_category}/${prevItems[0]?.item_category2}/${prevItems[0]?.item_category3}`,
                                allPrice
                              )
                            } else {
                              addToCart(
                                pixelContent_ids,
                                pixelContents as [{ name: string; quantity: number }],
                                `${listItem?.categories[0]?.categories[0]?.label}/${listItem?.categories[0]?.categories[1]?.label}/${listItem?.categories[0]?.categories[2]?.label}`,
                                allPrice
                              )
                            }
                          } else if (location.pathname.includes('exhibitiondetail')) {
                            addToCart(
                              pixelContent_ids,
                              pixelContents as [{ name: string; quantity: number }],
                              `${exhibitionCategory?.depth1Label}/${
                                exhibitionCategory?.depth2Label ? exhibitionCategory?.depth2Label : ''
                              }/${exhibitionCategory?.depth3Label ? exhibitionCategory?.depth3Label : ''}`,
                              allPrice
                            )
                          } else {
                            addToCart(
                              pixelContent_ids,
                              pixelContents as [{ name: string; quantity: number }],
                              `${filterCategory[0]?.depth1Label}/${filterCategory[0]?.depth2Label}/${filterCategory[0]?.depth3Label},`,
                              allPrice
                            )
                          }

                          postGuestCart(mergedData)
                            .then((res) => {
                              const cleanPath = location.pathname.replace(/\/$/, '')
                              if (res.data.invalidProducts.length !== 0) {
                                alert('구매불가한 상품이 있습니다.')
                                closeModal()
                                return
                              }
                              window.sessionStorage.setItem('guestCart', JSON.stringify(mergedData))
                              setIsToast(true)
                              setToastMessage('상품이 장바구니에 담겼습니다.')
                              setToastBtnMessage('바로가기')
                              setToastEvent(() => () => {
                                if (isAppView) {
                                  RNPostMessage(AFWebLinkType.moveToLink, {
                                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/cart`,
                                  })
                                } else {
                                  navigate('/cart')
                                }
                              })
                              closeModal()
                              setAddCart((prev: boolean) => !prev)
                              if (location.pathname.includes('product')) {
                                //물품상세
                                const gtmarray: any = []
                                const price: number = 0
                                let orderCnt: number = 0
                                productArray.map((el: any) => {
                                  if (prevItems && prevItems.length !== 0) {
                                    let optionValue
                                    for (let j = 0; j < floatOption.length; j++) {
                                      if (el.optionNo === floatOption[j].optionNo) {
                                        optionValue = floatOption[j].value
                                      }
                                    }
                                    const obj = {
                                      item_id: String(product?.baseInfo?.productNo),
                                      item_name: product?.baseInfo?.productName,
                                      affiliation: '어바웃피싱',
                                      item_list_price: product?.price?.salePrice,
                                      item_selling_price:
                                        product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                      price: product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                      quantity: el.orderCnt,
                                      item_total_discount: product?.price?.immediateDiscountAmt,
                                      discount: 0,
                                      index: '',
                                      item_brand: product?.brand?.name,
                                      item_category: prevItems[0]?.item_category,
                                      item_category2: prevItems[0]?.item_category2,
                                      item_category3: prevItems[0]?.item_category3,
                                      item_variant: optionValue,
                                      item_list_id: String(prevItems[0]?.item_list_id),
                                      item_list_name: prevItems[0]?.item_list_name,
                                      promotion_id: String(prevItems[0].promotion_id),
                                      promotion_name: prevItems[0].promotion_name,
                                    }
                                    gtmarray.push(obj)

                                    const itemList = getParsedLocalStorageItem('cartlist')
                                    const array = [...itemList]
                                    let bol = false
                                    if (array.length === 0) {
                                      bol = false
                                    } else {
                                      array.map((el) => {
                                        if (Number(el.product) === Number(obj.item_id)) {
                                          bol = true
                                        } else {
                                          bol = false
                                        }
                                      })
                                    }
                                    if (bol) {
                                      return
                                    } else {
                                      array.push({
                                        promotion_id: obj.promotion_id ? obj.promotion_id : '',
                                        promotion_name: obj.promotion_name ? obj.promotion_name : '',
                                        product: obj.item_id,
                                        item_list_id: obj.item_list_id,
                                        item_list_name: obj.item_list_name,
                                      })
                                    }

                                    window.localStorage.setItem('cartlist', JSON.stringify(array))
                                  } else {
                                    let optionValue
                                    for (let j = 0; j < floatOption.length; j++) {
                                      if (el.optionNo === floatOption[j].optionNo) {
                                        optionValue = floatOption[j].value
                                      }
                                    }
                                    const obj = {
                                      item_id: String(product?.baseInfo?.productNo),
                                      item_name: product?.baseInfo?.productName,
                                      affiliation: '어바웃피싱',
                                      item_list_price: product?.price?.salePrice,
                                      item_selling_price:
                                        product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                      price: product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                      quantity: el.orderCnt,
                                      item_total_discount: product?.price?.immediateDiscountAmt,
                                      discount: 0,
                                      index: '',
                                      item_brand: product?.brand?.name,
                                      item_category: listItem?.categories[0]?.categories[0]?.label,
                                      item_category2: listItem?.categories[0]?.categories[1]?.label,
                                      item_category3: listItem?.categories[0]?.categories[2]?.label,
                                      item_variant: optionValue,
                                      item_list_id: String(listItem?.categories[0]?.categories[1]?.categoryNo),
                                      item_list_name: listItem?.categories[0]?.categories[1]?.label,
                                      payback: product?.price?.accumulationAmtWhenBuyConfirm,
                                      reserve_discount: Number(
                                        formatNumberWithTruncation(
                                          (product?.price?.salePrice - product?.price?.immediateDiscountAmt) * 0.1
                                        ).replaceAll(',', '')
                                      ),
                                    }

                                    gtmarray.push(obj)
                                    const itemList = getParsedLocalStorageItem('cartlist')
                                    const array = [...itemList]
                                    const listArray: any = []
                                    let bol = false
                                    if (array.length === 0) {
                                      bol = false
                                    } else {
                                      array.map((el) => {
                                        if (Number(el.product) === Number(obj.item_id)) {
                                          bol = true
                                        } else {
                                          bol = false
                                        }
                                      })
                                    }
                                    if (bol) {
                                      return
                                    } else {
                                      listArray.push({
                                        promotion_id: '',
                                        promotion_name: '',
                                        product: obj.item_id,
                                        item_list_id: obj.item_list_id,
                                        item_list_name: obj.item_list_name,
                                      })

                                      window.localStorage.setItem('cartlist', JSON.stringify(listArray))
                                    }
                                  }
                                })

                                for (let i = 0; i < productArray.length; i++) {
                                  orderCnt += Number(productArray[i].orderCnt)
                                }
                                //@ts-ignore
                                NA_CART(selectItem?.baseInfo?.productNo, selectItem?.baseInfo?.productName, orderCnt)
                                const addCartItem: DataLayerArgs = {
                                  dataLayer: {
                                    event: 'add_to_cart', // ecommerce 이벤트 중 상품보기 단계
                                    ecommerce: {
                                      currency: 'KRW',
                                      value: allPrice,
                                      items: gtmarray,
                                      payback: product?.price?.accumulationAmtWhenBuyConfirm,
                                      reserve_discount: 0,
                                    },
                                  },
                                }
                                if (isAppView) {
                                  sendSetAppsflyerEvent({
                                    eventName: 'add_to_cart',
                                    eventType: {
                                      currency: 'KRW',
                                      value: allPrice,
                                      items: gtmarray,
                                      payback: product?.price?.accumulationAmtWhenBuyConfirm,
                                      reserve_discount: 0,
                                    },
                                  })
                                } else if (!isAppView) {
                                  TagManager.dataLayer(addCartItem)
                                }
                              } else if (location.pathname.includes('exhibitiondetail')) {
                                //기획전
                                const gtmarray: any = []
                                let price: number = 0
                                let orderCnt: number = 0
                                productArray.map((el: any) => {
                                  let optionValue
                                  for (let j = 0; j < floatOption.length; j++) {
                                    if (el.optionNo === floatOption[j].optionNo) {
                                      optionValue = floatOption[j].value
                                    }
                                  }
                                  const obj = {
                                    item_id: String(selectItem?.productNo),
                                    item_name: selectItem?.productName,
                                    affiliation: '어바웃피싱',
                                    item_list_price: selectItem?.salePrice,
                                    item_selling_price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                    price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                    quantity: el.orderCnt,
                                    item_total_discount: selectItem?.immediateDiscountAmt,
                                    discount: 0,
                                    index: idx,
                                    item_brand: selectItem?.brandName,
                                    item_category: exhibitionCategory?.depth1Label,
                                    item_category2: exhibitionCategory?.depth2Label,
                                    item_category3: exhibitionCategory?.depth3Label,
                                    item_variant: optionValue,
                                    promotion_id: String(promotion_id),
                                    promotion_name: promotion_name,
                                  }
                                  gtmarray.push(obj)
                                  const itemList = getParsedLocalStorageItem('cartlist')
                                  const array = [...itemList]
                                  let bol = false
                                  if (array.length === 0) {
                                    bol = false
                                  } else {
                                    array.map((el) => {
                                      if (Number(el.product) === Number(obj.item_id)) {
                                        bol = true
                                      } else {
                                        bol = false
                                      }
                                    })
                                  }
                                  if (bol) {
                                    return
                                  } else {
                                    array.push({
                                      promotion_id: obj.promotion_id,
                                      promotion_name: obj.promotion_name,
                                      product: obj.item_id,
                                      item_list_id: '',
                                      item_list_name: '',
                                    })
                                  }

                                  window.localStorage.setItem('cartlist', JSON.stringify(array))
                                })
                                for (let i = 0; i < gtmarray.length; i++) {
                                  price += gtmarray[i].price * gtmarray[i].quantity
                                  orderCnt += gtmarray[i].quantity
                                }
                                //@ts-ignore
                                NA_CART(selectItem?.productNo, selectItem?.productName, orderCnt)

                                const addCartItem: DataLayerArgs = {
                                  dataLayer: {
                                    event: 'add_to_cart', // ecommerce 이벤트 중 상품보기 단계
                                    ecommerce: {
                                      currency: 'KRW',
                                      value: allPrice,
                                      items: gtmarray,
                                    },
                                  },
                                }
                                if (isAppView) {
                                  sendSetAppsflyerEvent({
                                    eventName: 'add_to_cart',
                                    eventType: {
                                      currency: 'KRW',
                                      value: allPrice,
                                      items: gtmarray,
                                      payback: product?.price?.accumulationAmtWhenBuyConfirm,
                                      reserve_discount: 0,
                                    },
                                  })
                                } else {
                                  TagManager.dataLayer(addCartItem)
                                }
                              } else if (cleanPath === '') {
                                //홈모듈
                                const gtmarray: any = []
                                let orderCnt: number = 0
                                productArray.map((el: any) => {
                                  let optionValue
                                  for (let j = 0; j < floatOption.length; j++) {
                                    if (el.optionNo === floatOption[j].optionNo) {
                                      optionValue = floatOption[j].value
                                    }
                                  }
                                  const obj = {
                                    item_id: String(selectItem?.productNo),
                                    item_name: selectItem?.productName,
                                    affiliation: '어바웃피싱',
                                    item_list_price: selectItem?.salePrice,
                                    item_selling_price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                    price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                    quantity: el.orderCnt,
                                    item_total_discount: selectItem?.immediateDiscountAmt,
                                    discount: 0,
                                    index: idx,
                                    item_brand: selectItem?.brandName,
                                    item_category: filterCategory[0]?.depth1Label,
                                    item_category2: filterCategory[0]?.depth2Label,
                                    item_category3: filterCategory[0]?.depth3Label,
                                    item_variant: optionValue,
                                    item_list_id: String(listId),
                                    item_list_name: listName,
                                  }
                                  gtmarray.push(obj)
                                  const itemList = getParsedLocalStorageItem('cartlist')
                                  const array = [...itemList]
                                  let bol = false
                                  if (array.length === 0) {
                                    bol = false
                                  } else {
                                    array.map((el) => {
                                      if (Number(el.product) === Number(obj.item_id)) {
                                        bol = true
                                      } else {
                                        bol = false
                                      }
                                    })
                                  }
                                  if (!bol) {
                                    array.push({
                                      promotion_id: '',
                                      promotion_name: '',
                                      product: obj.item_id,
                                      item_list_id: obj.item_list_id,
                                      item_list_name: obj.item_list_name,
                                    })
                                  }
                                  window.localStorage.setItem('cartlist', JSON.stringify(array))
                                })
                                for (let i = 0; i < productArray.length; i++) {
                                  orderCnt += Number(productArray[i].orderCnt)
                                }
                                //@ts-ignore
                                NA_CART(selectItem?.productNo, selectItem?.productName, orderCnt)
                                const addCartItem: DataLayerArgs = {
                                  dataLayer: {
                                    event: 'add_to_cart', // ecommerce 이벤트 중 상품보기 단계
                                    ecommerce: {
                                      currency: 'KRW',
                                      value: allPrice,
                                      items: gtmarray,
                                    },
                                  },
                                }
                                if (isAppView) {
                                  sendSetAppsflyerEvent({
                                    eventName: 'add_to_cart',
                                    eventType: {
                                      currency: 'KRW',
                                      value: allPrice,
                                      items: gtmarray,
                                    },
                                  })
                                } else if (!isAppView) {
                                  TagManager.dataLayer(addCartItem)
                                }
                              } else {
                                const gtmarray: any = []
                                let price: number = 0
                                let orderCnt: number = 0
                                productArray.map((el: any) => {
                                  let optionValue
                                  for (let j = 0; j < floatOption.length; j++) {
                                    if (el.optionNo === floatOption[j].optionNo) {
                                      optionValue = floatOption[j].value
                                    }
                                  }
                                  const obj = {
                                    item_id: String(selectItem?.productNo),
                                    item_name: selectItem?.productName,
                                    affiliation: '어바웃피싱',
                                    item_list_price: selectItem?.salePrice,
                                    item_selling_price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                    price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                    quantity: el.orderCnt,
                                    item_total_discount: selectItem?.immediateDiscountAmt,
                                    discount: 0,
                                    index: idx,
                                    item_brand: selectItem?.brandName,
                                    item_category: filterCategory[0]?.depth1Label,
                                    item_category2: filterCategory[0]?.depth2Label,
                                    item_category3: filterCategory[0]?.depth3Label,
                                    item_variant: optionValue,
                                    item_list_id: String(filterCategory[0]?.depth3CategoryNo),
                                    item_list_name: filterCategory[0]?.depth3Label,
                                  }
                                  gtmarray.push(obj)
                                  const itemList = getParsedLocalStorageItem('cartlist')
                                  const array = [...itemList]
                                  let bol = false
                                  if (array.length === 0) {
                                    bol = false
                                  } else {
                                    array.map((el) => {
                                      if (
                                        Number(el.product) === Number(obj.item_id) &&
                                        el.item_list_id === Number(obj.item_list_id)
                                      ) {
                                        bol = true
                                      } else {
                                        bol = false
                                      }
                                    })
                                  }
                                  if (bol) {
                                    return
                                  } else {
                                    array.push({
                                      promotion_id: '',
                                      promotion_name: '',
                                      product: obj.item_id,
                                      item_list_id: obj.item_list_id,
                                      item_list_name: obj.item_list_name,
                                    })
                                  }

                                  window.localStorage.setItem('cartlist', JSON.stringify(array))
                                })
                                for (let i = 0; i < gtmarray.length; i++) {
                                  price += gtmarray[i].price * gtmarray[i].quantity
                                  orderCnt += gtmarray[i].quantity
                                }

                                //@ts-ignore
                                NA_CART(selectItem?.productNo, selectItem?.productName, orderCnt)

                                const addCartItem: DataLayerArgs = {
                                  dataLayer: {
                                    event: 'add_to_cart', // ecommerce 이벤트 중 상품보기 단계
                                    ecommerce: {
                                      currency: 'KRW',
                                      value: allPrice,
                                      items: gtmarray,
                                    },
                                  },
                                }
                                if (isAppView) {
                                  sendSetAppsflyerEvent({
                                    eventName: 'add_to_cart',
                                    eventType: {
                                      currency: 'KRW',
                                      value: allPrice,
                                      items: gtmarray,
                                    },
                                  })
                                } else {
                                  TagManager.dataLayer(addCartItem)
                                }
                              }
                            })
                            .catch((err) => {
                              console.log(err)
                            })
                        } else {
                          alert('비회원 구매 불가 상품입니다.')
                          return
                        }
                      }
                    } else {
                      alert('옵션을 선택해주세요')
                    }
                  }}
                >
                  장바구니 담기
                </CartBtnLeft>
                {!location.pathname.includes('/exhibitiondetail/43284') && (
                  <CartBtnRight
                    onClick={() => {
                      if (wonShop.length !== 0 || wonShopBol) {
                        alert('100원샵 상품은 장바구니에 담은 후 구매 가능합니다')
                        return
                      } else {
                        if (productArray.length !== 0) {
                          if (hasAccessToken) {
                            postUserOrderSheets([], productArray)
                              .then((res) => {
                                // goOrder(isMobile ? 'mobile' : 'pc');
                                handlePostMessage({
                                  actionType: 'goOrder',
                                  params: {
                                    mobile: isMobile ? 'mobile' : 'pc',
                                  },
                                })
                                if (isAppView) {
                                  RNPostMessage(AFWebLinkType.moveToLink, {
                                    url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/order/${res.data.orderSheetNo}`,
                                  })
                                } else {
                                  navigate(`/order/${res.data.orderSheetNo}`)
                                }
                                if (location.pathname.includes('product')) {
                                  const gtmarray: any = []
                                  productArray.map((el: any) => {
                                    if (prevItems && prevItems.length !== 0) {
                                      let optionValue
                                      for (let j = 0; j < floatOption.length; j++) {
                                        if (el.optionNo === floatOption[j].optionNo) {
                                          optionValue = floatOption[j].value
                                        }
                                      }
                                      const obj = {
                                        item_id: String(product?.baseInfo?.productNo),
                                        item_name: product?.baseInfo?.productName,
                                        affiliation: '어바웃피싱',
                                        item_list_price: product?.price?.salePrice,
                                        item_selling_price:
                                          product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                        price: product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                        quantity: el.orderCnt,
                                        item_total_discount: product?.price?.immediateDiscountAmt,
                                        discount: 0,
                                        index: '',
                                        item_brand: product?.brand?.name,
                                        item_category: prevItems[0]?.item_category,
                                        item_category2: prevItems[0]?.item_category2,
                                        item_category3: prevItems[0]?.item_category3,
                                        item_variant: optionValue,
                                        item_list_id: String(prevItems[0]?.item_list_id),
                                        item_list_name: prevItems[0]?.item_list_name,
                                        promotion_id: String(prevItems[0].promotion_id),
                                        promotion_name: prevItems[0].promotion_name,
                                      }
                                      gtmarray.push(obj)

                                      const itemList = getParsedLocalStorageItem('cartlist')
                                      const array = [...itemList]
                                      let bol = false
                                      if (array.length === 0) {
                                        bol = false
                                      } else {
                                        array.map((el) => {
                                          if (Number(el.product) === Number(obj.item_id)) {
                                            bol = true
                                          } else {
                                            bol = false
                                          }
                                        })
                                      }
                                      if (bol) {
                                        return
                                      } else {
                                        array.push({
                                          promotion_id: obj.promotion_id ? obj.promotion_id : '',
                                          promotion_name: obj.promotion_name ? obj.promotion_name : '',
                                          product: obj.item_id,
                                          item_list_id: obj.item_list_id ? obj.item_list_id : '',
                                          item_list_name: obj.item_list_name ? obj.item_list_name : '',
                                        })
                                      }

                                      window.localStorage.setItem('cartlist', JSON.stringify(array))
                                    } else {
                                      let optionValue
                                      for (let j = 0; j < floatOption.length; j++) {
                                        if (el.optionNo === floatOption[j].optionNo) {
                                          optionValue = floatOption[j].value
                                        }
                                      }
                                      // let obj = {
                                      //   item_id: String(selectItem?.baseInfo?.productNo),
                                      //   item_name: selectItem?.baseInfo?.productName,
                                      //   affiliation: '어바웃피싱',
                                      //   item_list_price: selectItem?.price?.salePrice,
                                      //   item_selling_price:
                                      //     selectItem?.price?.salePrice - selectItem?.price?.immediateDiscountAmt,
                                      //   price: selectItem?.price?.salePrice - selectItem?.price?.immediateDiscountAmt,
                                      //   quantity: el.orderCnt,
                                      //   item_total_discount: selectItem?.price?.immediateDiscountAmt,
                                      //   discount: 0,
                                      //   index: '',
                                      //   item_brand: selectItem?.brand?.name,
                                      //   item_category: listItem?.categories[0].categories[0]?.label,
                                      //   item_category2: listItem?.categories[0].categories[1]?.label,
                                      //   item_category3: listItem?.categories[0].categories[2]?.label,
                                      //   item_variant: optionValue,
                                      //   item_list_id: listItem?.categories[0].categories[1]?.categoryNo,
                                      //   item_list_name: listItem?.categories[0].categories[1]?.label,
                                      //   payback: selectItem?.price.accumulationAmtWhenBuyConfirm,
                                      //   reserve_discount: Number(
                                      //     formatNumberWithTruncation(
                                      //       (selectItem?.price?.salePrice - selectItem?.price?.immediateDiscountAmt) *
                                      //         0.1,
                                      //     ).replaceAll(',', ''),
                                      //   ),
                                      // };

                                      const obj = {
                                        item_id: String(product?.baseInfo?.productNo),
                                        item_name: product?.baseInfo?.productName,
                                        affiliation: '어바웃피싱',
                                        item_list_price: product?.price?.salePrice,
                                        item_selling_price:
                                          product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                        price: product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                        quantity: el.orderCnt,
                                        item_total_discount: product?.price?.immediateDiscountAmt,
                                        discount: 0,
                                        index: '',
                                        item_brand: product?.brand?.name,
                                        item_category: listItem?.categories[0]?.categories[0]?.label,
                                        item_category2: listItem?.categories[0]?.categories[1]?.label,
                                        item_category3: listItem?.categories[0]?.categories[2]?.label,
                                        item_variant: optionValue,
                                        item_list_id: String(listItem?.categories[0]?.categories[1]?.categoryNo),
                                        item_list_name: listItem?.categories[0]?.categories[1]?.label,
                                        payback: product?.price?.accumulationAmtWhenBuyConfirm,
                                        reserve_discount: Number(
                                          formatNumberWithTruncation(
                                            (product?.price?.salePrice - product?.price?.immediateDiscountAmt) * 0.1
                                          ).replaceAll(',', '')
                                        ),
                                      }

                                      gtmarray.push(obj)
                                      const itemList = getParsedLocalStorageItem('cartlist')
                                      const array = [...itemList]
                                      const listArray: any = []
                                      let bol = false
                                      if (array.length === 0) {
                                        bol = false
                                      } else {
                                        array.map((el) => {
                                          if (Number(el.product) === Number(obj.item_id)) {
                                            bol = true
                                          } else {
                                            bol = false
                                          }
                                        })
                                      }
                                      if (bol) {
                                        return
                                      } else {
                                        listArray.push({
                                          promotion_id: '',
                                          promotion_name: '',
                                          product: obj.item_id,
                                          item_list_id: obj.item_list_id,
                                          item_list_name: obj.item_list_name,
                                        })

                                        window.localStorage.setItem('cartlist', JSON.stringify(listArray))
                                      }
                                    }
                                  })
                                } else if (location.pathname.includes('exhibitiondetail')) {
                                  const gtmarray: any = []
                                  productArray.map((el: any) => {
                                    let optionValue
                                    for (let j = 0; j < floatOption.length; j++) {
                                      if (el.optionNo === floatOption[j].optionNo) {
                                        optionValue = floatOption[j].value
                                      }
                                    }
                                    const obj = {
                                      item_id: String(selectItem?.productNo),
                                      item_name: selectItem?.productName,
                                      affiliation: '어바웃피싱',
                                      item_list_price: selectItem?.salePrice,
                                      item_selling_price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                      price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                      quantity: el.orderCnt,
                                      item_total_discount: selectItem?.immediateDiscountAmt,
                                      discount: 0,
                                      index: idx,
                                      item_brand: selectItem?.brandName,
                                      item_category: exhibitionCategory?.depth1Label,
                                      item_category2: exhibitionCategory?.depth2Label,
                                      item_category3: exhibitionCategory?.depth3Label,
                                      item_variant: optionValue,
                                      promotion_id: String(promotion_id),
                                      promotion_name: promotion_name,
                                    }
                                    gtmarray.push(obj)
                                    const itemList = getParsedLocalStorageItem('cartlist')
                                    const array = [...itemList]
                                    let bol = false
                                    if (array.length === 0) {
                                      bol = false
                                    } else {
                                      array.map((el) => {
                                        if (Number(el.product) === Number(obj.item_id)) {
                                          bol = true
                                        } else {
                                          bol = false
                                        }
                                      })
                                    }
                                    if (bol) {
                                      return
                                    } else {
                                      array.push({
                                        promotion_id: obj.promotion_id,
                                        promotion_name: obj.promotion_name,
                                        product: obj.item_id,
                                        item_list_id: '',
                                        item_list_name: '',
                                      })
                                    }

                                    window.localStorage.setItem('cartlist', JSON.stringify(array))
                                  })
                                } else {
                                  const gtmarray: any = []
                                  productArray.map((el: any) => {
                                    let optionValue
                                    for (let j = 0; j < floatOption.length; j++) {
                                      if (el.optionNo === floatOption[j].optionNo) {
                                        optionValue = floatOption[j].value
                                      }
                                    }
                                    const obj = {
                                      item_id: String(selectItem?.productNo),
                                      item_name: selectItem?.productName,
                                      affiliation: '어바웃피싱',
                                      item_list_price: selectItem?.salePrice,
                                      item_selling_price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                      price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                      quantity: el.orderCnt,
                                      item_total_discount: selectItem?.immediateDiscountAmt,
                                      discount: 0,
                                      index: idx,
                                      item_brand: selectItem?.brandName,
                                      item_category: filterCategory[0]?.depth1Label,
                                      item_category2: filterCategory[0]?.depth2Label,
                                      item_category3: filterCategory[0]?.depth3Label,
                                      item_variant: optionValue,
                                      item_list_id: String(filterCategory[0]?.depth3CategoryNo),
                                      item_list_name: filterCategory[0]?.depth3Label,
                                    }
                                    gtmarray.push(obj)
                                    const itemList = getParsedLocalStorageItem('cartlist')
                                    const array = [...itemList]
                                    let bol = false
                                    if (array.length === 0) {
                                      bol = false
                                    } else {
                                      array.map((el) => {
                                        if (Number(el.product) === Number(obj.item_id)) {
                                          bol = true
                                        } else {
                                          bol = false
                                        }
                                      })
                                    }
                                    if (bol) {
                                      return
                                    } else {
                                      array.push({
                                        promotion_id: '',
                                        promotion_name: '',
                                        product: obj.item_id,
                                        item_list_id: obj.item_list_id,
                                        item_list_name: obj.item_list_name,
                                      })
                                    }

                                    window.localStorage.setItem('cartlist', JSON.stringify(array))
                                  })
                                }
                              })
                              .catch((err) => alert('구매옵션을 확인해 주세요'))
                          } else {
                            if (!memberCheck) {
                              postGuestOrderSheets([], productArray)
                                .then((res) => {
                                  // goOrder(isMobile ? 'mobile' : 'pc');
                                  handlePostMessage({
                                    actionType: 'goOrder',
                                    params: {
                                      mobile: isMobile ? 'mobile' : 'pc',
                                    },
                                  })

                                  if (isAppView) {
                                    RNPostMessage(AFWebLinkType.moveToLink, {
                                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/order/${res.data.orderSheetNo}`,
                                    })
                                  } else {
                                    navigate(`/order/${res.data.orderSheetNo}`)
                                  }
                                  if (location.pathname.includes('product')) {
                                    const gtmarray: any = []
                                    productArray.map((el: any) => {
                                      if (prevItems && prevItems.length !== 0) {
                                        let optionValue
                                        for (let j = 0; j < floatOption.length; j++) {
                                          if (el.optionNo === floatOption[j].optionNo) {
                                            optionValue = floatOption[j].value
                                          }
                                        }
                                        const obj = {
                                          item_id: String(product?.baseInfo?.productNo),
                                          item_name: product?.baseInfo?.productName,
                                          affiliation: '어바웃피싱',
                                          item_list_price: product?.price?.salePrice,
                                          item_selling_price:
                                            product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                          price: product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                          quantity: el.orderCnt,
                                          item_total_discount: product?.price?.immediateDiscountAmt,
                                          discount: 0,
                                          index: '',
                                          item_brand: product?.brand?.name,
                                          item_category: prevItems[0]?.item_category,
                                          item_category2: prevItems[0]?.item_category2,
                                          item_category3: prevItems[0]?.item_category3,
                                          item_variant: optionValue,
                                          item_list_id: String(prevItems[0]?.item_list_id),
                                          item_list_name: prevItems[0]?.item_list_name,
                                          promotion_id: String(prevItems[0].promotion_id),
                                          promotion_name: prevItems[0].promotion_name,
                                        }
                                        gtmarray.push(obj)

                                        const itemList = getParsedLocalStorageItem('cartlist')
                                        const array = [...itemList]
                                        let bol = false
                                        if (array.length === 0) {
                                          bol = false
                                        } else {
                                          array.map((el) => {
                                            if (Number(el.product) === Number(obj.item_id)) {
                                              bol = true
                                            } else {
                                              bol = false
                                            }
                                          })
                                        }
                                        if (bol) {
                                          return
                                        } else {
                                          array.push({
                                            promotion_id: obj.promotion_id ? obj.promotion_id : '',
                                            promotion_name: obj.promotion_name ? obj.promotion_name : '',
                                            product: obj.item_id,
                                            item_list_id: obj.item_list_id ? obj.item_list_id : '',
                                            item_list_name: obj.item_list_name ? obj.item_list_name : '',
                                          })
                                        }
                                        window.localStorage.setItem('cartlist', JSON.stringify(array))
                                      } else {
                                        let optionValue
                                        for (let j = 0; j < floatOption.length; j++) {
                                          if (el.optionNo === floatOption[j].optionNo) {
                                            optionValue = floatOption[j].value
                                          }
                                        }

                                        const obj = {
                                          item_id: String(product?.baseInfo?.productNo),
                                          item_name: product?.baseInfo?.productName,
                                          affiliation: '어바웃피싱',
                                          item_list_price: product?.price?.salePrice,
                                          item_selling_price:
                                            product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                          price: product?.price?.salePrice - product?.price?.immediateDiscountAmt,
                                          quantity: el.orderCnt,
                                          item_total_discount: product?.price?.immediateDiscountAmt,
                                          discount: 0,
                                          index: '',
                                          item_brand: product?.brand?.name,
                                          item_category: listItem?.categories[0]?.categories[0]?.label,
                                          item_category2: listItem?.categories[0]?.categories[1]?.label,
                                          item_category3: listItem?.categories[0]?.categories[2]?.label,
                                          item_variant: optionValue,
                                          item_list_id: String(listItem?.categories[0]?.categories[1]?.categoryNo),
                                          item_list_name: listItem?.categories[0]?.categories[1]?.label,
                                          payback: product?.price?.accumulationAmtWhenBuyConfirm,
                                          reserve_discount: Number(
                                            formatNumberWithTruncation(
                                              (product?.price?.salePrice - product?.price?.immediateDiscountAmt) * 0.1
                                            ).replaceAll(',', '')
                                          ),
                                        }

                                        gtmarray.push(obj)
                                        const itemList = getParsedLocalStorageItem('cartlist')
                                        const array = [...itemList]
                                        const listArray: any = []
                                        let bol = false
                                        if (array.length === 0) {
                                          bol = false
                                        } else {
                                          array.map((el) => {
                                            if (Number(el.product) === Number(obj.item_id)) {
                                              bol = true
                                            } else {
                                              bol = false
                                            }
                                          })
                                        }
                                        if (bol) {
                                          return
                                        } else {
                                          listArray.push({
                                            promotion_id: '',
                                            promotion_name: '',
                                            product: obj.item_id,
                                            item_list_id: obj.item_list_id,
                                            item_list_name: obj.item_list_name,
                                          })

                                          window.localStorage.setItem('cartlist', JSON.stringify(listArray))
                                        }
                                      }
                                    })
                                  } else if (location.pathname.includes('exhibitiondetail')) {
                                    const gtmarray: any = []
                                    productArray.map((el: any) => {
                                      let optionValue
                                      for (let j = 0; j < floatOption.length; j++) {
                                        if (el.optionNo === floatOption[j].optionNo) {
                                          optionValue = floatOption[j].value
                                        }
                                      }
                                      const obj = {
                                        item_id: String(selectItem?.productNo),
                                        item_name: selectItem?.productName,
                                        affiliation: '어바웃피싱',
                                        item_list_price: selectItem?.salePrice,
                                        item_selling_price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                        price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                        quantity: el.orderCnt,
                                        item_total_discount: selectItem?.immediateDiscountAmt,
                                        discount: 0,
                                        index: idx,
                                        item_brand: selectItem?.brandName,
                                        item_category: exhibitionCategory?.depth1Label,
                                        item_category2: exhibitionCategory?.depth2Label,
                                        item_category3: exhibitionCategory?.depth3Label,
                                        item_variant: optionValue,
                                        promotion_id: String(promotion_id),
                                        promotion_name: promotion_name,
                                      }
                                      gtmarray.push(obj)
                                      const itemList = getParsedLocalStorageItem('cartlist')
                                      const array = [...itemList]
                                      let bol = false
                                      if (array.length === 0) {
                                        bol = false
                                      } else {
                                        array.map((el) => {
                                          if (Number(el.product) === Number(obj.item_id)) {
                                            bol = true
                                          } else {
                                            bol = false
                                          }
                                        })
                                      }
                                      if (bol) {
                                        return
                                      } else {
                                        array.push({
                                          promotion_id: obj.promotion_id,
                                          promotion_name: obj.promotion_name,
                                          product: obj.item_id,
                                          item_list_id: '',
                                          item_list_name: '',
                                        })
                                      }

                                      window.localStorage.setItem('cartlist', JSON.stringify(array))
                                    })
                                  } else {
                                    const gtmarray: any = []
                                    productArray.map((el: any) => {
                                      let optionValue
                                      for (let j = 0; j < floatOption.length; j++) {
                                        if (el.optionNo === floatOption[j].optionNo) {
                                          optionValue = floatOption[j].value
                                        }
                                      }
                                      const obj = {
                                        item_id: String(selectItem?.productNo),
                                        item_name: selectItem?.productName,
                                        affiliation: '어바웃피싱',
                                        item_list_price: selectItem?.salePrice,
                                        item_selling_price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                        price: selectItem?.salePrice - selectItem?.immediateDiscountAmt,
                                        quantity: el.orderCnt,
                                        item_total_discount: selectItem?.immediateDiscountAmt,
                                        discount: 0,
                                        index: idx,
                                        item_brand: selectItem?.brandName,
                                        item_category: filterCategory[0]?.depth1Label,
                                        item_category2: filterCategory[0]?.depth2Label,
                                        item_category3: filterCategory[0]?.depth3Label,
                                        item_variant: optionValue,
                                        item_list_id: String(filterCategory[0]?.depth3CategoryNo),
                                        item_list_name: filterCategory[0]?.depth3Label,
                                      }
                                      gtmarray.push(obj)
                                      const itemList = getParsedLocalStorageItem('cartlist')
                                      const array = [...itemList]
                                      let bol = false
                                      if (array.length === 0) {
                                        bol = false
                                      } else {
                                        array.map((el) => {
                                          if (Number(el.product) === Number(obj.item_id)) {
                                            bol = true
                                          } else {
                                            bol = false
                                          }
                                        })
                                      }
                                      if (bol) {
                                        return
                                      } else {
                                        array.push({
                                          promotion_id: '',
                                          promotion_name: '',
                                          product: obj.item_id,
                                          item_list_id: obj.item_list_id,
                                          item_list_name: obj.item_list_name,
                                        })
                                      }

                                      window.localStorage.setItem('cartlist', JSON.stringify(array))
                                    })
                                  }
                                })
                                .catch((err) => alert('구매옵션을 확인해 주세요'))
                            } else {
                              alert('비회원 구매 불가 상품입니다.')
                              return
                            }
                          }
                        } else {
                          alert('옵션을 선택해주세요')
                        }
                      }
                    }}
                  >
                    구매하기
                  </CartBtnRight>
                )}
              </CartBtnWrap>
              {!hasAccessToken ? (
                <NPay
                  onClick={() => {
                    const userConfirmed = window.confirm('npay로 구매하면 네이버에서만 주문내역을 확인할 수 있습니다.')
                    if (userConfirmed) {
                      if (productArray.length !== 0) {
                        if (!memberCheck) {
                          if (isAppView) {
                            postNaverOrderSheet(productArray, true).then((res) => {
                              moveToLinkNaver(res.data)
                              RNPostMessage(AFWebLinkType.moveToLink, {
                                url: `aboutfishing://aboutfishing.com/?page=webview&url=${res.data}`,
                              })
                            })
                          } else {
                            const open = window.open('about:blank', '_blank')
                            postNaverOrderSheet(productArray, false).then((res) => {
                              // window.open(
                              //   `${process.env.process.env.REACT_APP_SHOP_URL}/naverpay?naverUrl=${res.data}`
                              // );

                              //@ts-ignore
                              open.location.href = res.data
                            })
                          }
                          closeModal()
                        } else {
                          alert('비회원 구매 불가 상품입니다.')
                          return
                        }
                      } else {
                        alert('옵션을 선택해주세요')
                      }
                    } else {
                      // 사용자가 "취소" 버튼을 눌렀을 때 실행할 코드
                      console.log('사용자가 작업을 취소했습니다.')
                    }
                  }}
                >
                  <img src='/images/icon_npay_logo.png' alt='npay 로고' />
                  <p>구매하기</p>
                </NPay>
              ) : null}
            </ModalFooter>
          </div>
        </ModalBox>
        <ModalBackground onClick={closeModal} closing={closing}></ModalBackground>
      </ModalWrap>
    </>
  )
}

export function SelectOption({
  el,
  selectOption,
  setSelectOption,
  setSelectOptionTitle,
  allCount,
  idx,
  setAllCount,
  setProductArray,
  productArray,
  selectProductNo,
  selectOptionTitle,
  checkChange,
  setAllPrice,
  floatOption,
}: any) {
  const [count, setCount] = useState(productArray[idx]?.orderCnt ? productArray[idx]?.orderCnt : 1)
  const countRef = useRef<HTMLInputElement>(null)
  const [price, setPrice] = useState<number>(0)
  const [optionTitle, setOptionTitle] = useState<any>()
  //카운트 변경 적용
  useEffect(() => {
    if (countRef.current !== null) {
      countRef.current.value = String(count)
    }
  }, [count])

  useEffect(() => {
    if (floatOption) {
      floatOption.map((element: any) => {
        if (element.optionNo === el.optionNo) {
          setOptionTitle(element)
        }
      })
    }
  }, [floatOption])
  //가격 총합
  useEffect(() => {
    setPrice(Number(el.buyPrice * count))
    const obj = {
      productNo: Number(selectProductNo),
      optionNo: el.optionNo,
      orderCnt: count,
      channelType: null,
      cartNo: null,
    }
    updateArray(idx, obj)
    updateNthElement(idx, el.buyPrice * count)
  }, [count, checkChange])
  //가격 정보 상위 컴포넌트에 올려주기위해 업데이트
  // useEffect(() => {
  //   // updateNthElement(idx, price);
  //   setAllPrice((prev: any) => prev + price);
  // }, [price]);
  //배열 업데이트
  const updateNthElement = (idx: any, newValue: any) => {
    // 배열의 복사본을 만들어서 해당 인덱스의 값을 변경
    const newArr = [...allCount]
    newArr[idx] = newValue
    // 변경된 배열을 상태로 설정
    setAllCount(newArr)
  }

  const updateArray = (idx: any, newValue: any) => {
    // 배열의 복사본을 만들어서 해당 인덱스의 값을 변경
    const newArr = [...productArray]
    newArr[idx] = newValue
    // 변경된 배열을 상태로 설정
    setProductArray(newArr)
  }

  return (
    <OptionWrap key={el.optionNo}>
      <OptionContentWrap style={{ marginBottom: '12px' }}>
        <OptionContentContent>옵션 : {`${optionTitle?.value}`}</OptionContentContent>
        <img
          src='/images/icon_close_gray.svg'
          alt=''
          onClick={() => {
            let array: any = []
            const newArr = [...allCount]
            const newProductArray = [...productArray]
            newArr.splice(idx, 1)
            newProductArray.splice(idx, 1)
            selectOption.map((element: any) => {
              if (el.optionNo === element.optionNo) {
                if (selectOption.length === 1) {
                  array = []
                  setSelectOptionTitle('옵션을 선택해주세요')
                }
              } else if (el.optioNo !== element.optionNo) {
                array.push(element)
              }
            })

            setAllCount(newArr)
            setSelectOption(array)
            setProductArray(newProductArray)
          }}
        />
      </OptionContentWrap>
      <OptionContentWrap>
        <BtnGroupQuantity>
          <button
            onClick={() => {
              if (count > 1) {
                setCount((prev: number) => prev - 1)
              }
            }}
          >
            <img src={`${imgURL}/icon_minus2.svg`} alt='감소' />
          </button>
          <input
            type='number'
            value={count}
            disabled={true}
            readOnly={true}
            onChange={() => {
              if (Number(countRef.current?.value) > el.stockCnt) {
                alert('재고 수량 이상 선택할 수 없습니다.')
                setCount(el.stockCnt)
              } else if (Number(countRef.current?.value) === 0) {
                alert('수량은 한개이상 선택하셔야합니다.')
                setCount(1)
              } else {
                setCount(Number(countRef.current?.value))
              }
            }}
            ref={countRef}
          />
          {count >= el.stockCnt ? (
            <button>
              <img src={`${imgURL}/icon_plus2.svg`} alt='증가' style={{ opacity: '0.2' }} />
            </button>
          ) : (
            <button
              onClick={() => {
                if (count < el.stockCnt) {
                  setCount((prev: number) => prev + 1)
                }
              }}
            >
              <img src={`${imgURL}/icon_plus2.svg`} alt='증가' />
            </button>
          )}
        </BtnGroupQuantity>
        <OptionPrice>{plusComma(el.buyPrice * count)}원</OptionPrice>
      </OptionContentWrap>
    </OptionWrap>
  )
}

export function SelectSecondOption({
  el,
  selectSecondOption,
  setSelectSecondOption,
  setSelectOptionTitle,
  allCount,
  idx,
  setAllCount,
  setProductArray,
  productArray,
  selectProductNo,
  selectOptionTitle,
  selectCopy,
  checkChange,
  setSelectCopy,
  floatOption,
}: any) {
  const [count, setCount] = useState(productArray[idx]?.orderCnt ? productArray[idx]?.orderCnt : 1)
  const countRef = useRef<HTMLInputElement>(null)
  const [price, setPrice] = useState<number>(0)
  const [check, setCheck] = useState(false)
  const [optionTitle, setOptionTitle] = useState<any>()
  //카운트 변경 적용
  useEffect(() => {
    if (countRef.current !== null) {
      countRef.current.value = String(count)
    }
  }, [count])
  useEffect(() => {
    if (floatOption) {
      floatOption.map((element: any) => {
        if (element.optionNo === el.optionNo) {
          setOptionTitle(element)
        }
      })
    }
  }, [floatOption])
  //가격 총합
  useEffect(() => {
    setPrice(Number(el.buyPrice * count))
    const obj = {
      productNo: Number(selectProductNo),
      optionNo: el.optionNo,
      orderCnt: count,
      channelType: null,
      cartNo: null,
    }

    updateNthElement(idx, el.buyPrice * count)
    updateArray(idx, obj)
  }, [count, checkChange])

  //가격 정보 상위 컴포넌트에 올려주기위해 업데이트
  //배열 업데이트
  const updateNthElement = (idx: any, newValue: any) => {
    // 배열의 복사본을 만들어서 해당 인덱스의 값을 변경
    const newArr = [...allCount]
    newArr[idx] = newValue
    // 변경된 배열을 상태로 설정
    setAllCount(newArr)
  }

  const updateArray = (idx: any, newValue: any) => {
    // 배열의 복사본을 만들어서 해당 인덱스의 값을 변경

    const newArr = [...productArray]
    newArr[idx] = newValue

    // 변경된 배열을 상태로 설정
    setProductArray(newArr)
  }

  return (
    <OptionWrap key={el.optionNo}>
      <OptionContentWrap style={{ marginBottom: '12px' }}>
        <OptionContentContent>옵션 : {`${optionTitle?.value}`}</OptionContentContent>
        <img
          src='/images/icon_close_gray.svg'
          alt=''
          onClick={() => {
            let array: any = []
            const newArr = [...allCount]
            const newProductArray = [...productArray]
            const newTextArray = [...selectCopy]
            newArr.splice(idx, 1)
            newProductArray.splice(idx, 1)
            newTextArray.splice(idx, 1)
            selectSecondOption.map((element: any) => {
              if (el.optionNo === element.optionNo) {
                if (selectSecondOption.length === 1) {
                  array = []
                  setSelectOptionTitle('옵션을 선택해주세요')
                }
              } else if (el.optioNo !== element.optionNo) {
                array.push(element)
              }
            })
            setSelectCopy(newTextArray)
            setAllCount(newArr)
            setSelectSecondOption(array)
            setProductArray(newProductArray)
          }}
        />
      </OptionContentWrap>
      <OptionContentWrap>
        <BtnGroupQuantity>
          <button
            onClick={() => {
              if (count > 1) {
                setCount((prev: number) => prev - 1)
              }
            }}
          >
            <img src={`${imgURL}/icon_minus2.svg`} alt='감소' />
          </button>
          <input
            type='number'
            value={count}
            disabled={true}
            readOnly={true}
            onChange={() => {
              if (Number(countRef.current?.value) > el.stockCnt) {
                alert('재고 수량 이상 선택할 수 없습니다.')
                setCount(el.stockCnt)
              } else if (Number(countRef.current?.value) === 0) {
                alert('수량은 한개이상 선택하셔야합니다.')
                setCount(1)
              } else {
                setCount(Number(countRef.current?.value))
              }
            }}
            ref={countRef}
          />
          {count >= el.stockCnt ? (
            <button>
              <img src={`${imgURL}/icon_plus2.svg`} alt='증가' style={{ opacity: '0.2' }} />
            </button>
          ) : (
            <button
              onClick={() => {
                if (count < el.stockCnt) {
                  setCount((prev: number) => prev + 1)
                }
              }}
            >
              <img src={`${imgURL}/icon_plus2.svg`} alt='증가' />
            </button>
          )}
        </BtnGroupQuantity>
        <OptionPrice>{plusComma(el.buyPrice * count)}원</OptionPrice>
      </OptionContentWrap>
    </OptionWrap>
  )
}

export function SelectThirdOption({
  el,
  selectSecondOption,
  setSelectSecondOption,
  setSelectOptionTitle,
  allCount,
  idx,
  setAllCount,
  setProductArray,
  productArray,
  selectProductNo,
  selectOptionTitle,
  selectCopy,
  checkChange,
  setSelectCopy,
  floatOption,
}: any) {
  const [count, setCount] = useState(productArray[idx]?.orderCnt ? productArray[idx]?.orderCnt : 1)
  const countRef = useRef<HTMLInputElement>(null)
  const [price, setPrice] = useState<number>(0)
  const [check, setCheck] = useState(false)
  const [optionTitle, setOptionTitle] = useState<any>()
  useEffect(() => {
    if (floatOption) {
      floatOption.map((element: any) => {
        if (element.optionNo === el.optionNo) {
          setOptionTitle(element)
        }
      })
    }
  }, [floatOption])
  //카운트 변경 적용
  useEffect(() => {
    if (countRef.current !== null) {
      countRef.current.value = String(count)
    }
  }, [count])
  //가격 총합
  useEffect(() => {
    setPrice(Number(el.buyPrice * count))
    const obj = {
      productNo: Number(selectProductNo),
      optionNo: el.optionNo,
      orderCnt: count,
      channelType: null,
      cartNo: null,
    }

    updateNthElement(idx, el.buyPrice * count)
    updateArray(idx, obj)
  }, [count, checkChange])

  //가격 정보 상위 컴포넌트에 올려주기위해 업데이트
  //배열 업데이트
  const updateNthElement = (idx: any, newValue: any) => {
    // 배열의 복사본을 만들어서 해당 인덱스의 값을 변경
    const newArr = [...allCount]
    newArr[idx] = newValue
    // 변경된 배열을 상태로 설정
    setAllCount(newArr)
  }

  const updateArray = (idx: any, newValue: any) => {
    // 배열의 복사본을 만들어서 해당 인덱스의 값을 변경

    const newArr = [...productArray]
    newArr[idx] = newValue

    // 변경된 배열을 상태로 설정
    setProductArray(newArr)
  }

  return (
    <OptionWrap key={el.optionNo}>
      <OptionContentWrap style={{ marginBottom: '12px' }}>
        <OptionContentContent>옵션 : {` ${optionTitle?.value}`}</OptionContentContent>
        <img
          src='/images/icon_close_gray.svg'
          alt=''
          onClick={() => {
            let array: any = []
            const newArr = [...allCount]
            const newProductArray = [...productArray]
            const newTextArray = [...selectCopy]
            newArr.splice(idx, 1)
            newProductArray.splice(idx, 1)
            newTextArray.splice(idx, 1)
            selectSecondOption.map((element: any) => {
              if (el.optionNo === element.optionNo) {
                if (selectSecondOption.length === 1) {
                  array = []
                  setSelectOptionTitle('옵션을 선택해주세요')
                }
              } else if (el.optioNo !== element.optionNo) {
                array.push(element)
              }
            })
            setSelectCopy(newTextArray)
            setAllCount(newArr)
            setSelectSecondOption(array)
            setProductArray(newProductArray)
          }}
        />
      </OptionContentWrap>
      <OptionContentWrap>
        <BtnGroupQuantity>
          <button
            onClick={() => {
              if (count > 1) {
                setCount((prev: number) => prev - 1)
              }
            }}
          >
            <img src={`${imgURL}/icon_minus2.svg`} alt='감소' />
          </button>
          <input
            type='number'
            value={count}
            disabled={true}
            readOnly={true}
            onChange={() => {
              if (Number(countRef.current?.value) > el.stockCnt) {
                alert('재고 수량 이상 선택할 수 없습니다.')
                setCount(el.stockCnt)
              } else if (Number(countRef.current?.value) === 0) {
                alert('수량은 한개이상 선택하셔야합니다.')
                setCount(1)
              } else {
                setCount(Number(countRef.current?.value))
              }
            }}
            ref={countRef}
          />
          {count >= el.stockCnt ? (
            <button>
              <img src={`${imgURL}/icon_plus2.svg`} alt='증가' style={{ opacity: '0.2' }} />
            </button>
          ) : (
            <button
              onClick={() => {
                if (count < el.stockCnt) {
                  setCount((prev: number) => prev + 1)
                }
              }}
            >
              <img src={`${imgURL}/icon_plus2.svg`} alt='증가' />
            </button>
          )}
        </BtnGroupQuantity>
        <OptionPrice>{plusComma(el.buyPrice * count)}원</OptionPrice>
      </OptionContentWrap>
    </OptionWrap>
  )
}

interface typeProps {
  closing?: boolean
  isIOS?: boolean
  isAppView?: boolean
}

export const ModalBackground = styled.div<typeProps>`
  width: 100%;
  height: 100vh;
  z-index: 20;
  background-color: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
  animation: ${({ closing }) => (closing ? fadeOut : fadeIn)} 0.3s ease-in-out;
`

export const ModalWrap = styled.div`
  justify-content: center;
  align-items: center;
  display: flex;
  width: 100%;
  height: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 40;
  overflow: hidden;
`

export const ModalBox = styled.div<typeProps>`
  width: 100%;
  background-color: var(--colWhite);
  border-radius: 22px 22px 0 0;
  animation: ${({ closing }) => (closing ? slideDown : slideUp)} 0.3s ease-in-out;
  position: absolute;
  z-index: 30;
  display: flex;
  flex-direction: column;
  bottom: 0;
  padding: ${({ isIOS, isAppView }) => (isIOS && isAppView ? '0px 0px 13px 0px' : '0px')};
`

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 18.5px 22px 0 33px;
  & button.btn_close {
    width: 41px;
    height: 48px;
    padding: 12px 8px 12px 9px;
    background: none;
    border: none;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
    }
  }
`

export const ModalBody = styled.div`
  padding: 0 33px;
`

export const ModalFooter = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 8px;
  padding: 12px 33px;
`

export const CartBtnWrap = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  width: 100%;
`
export const CartBtnLeft = styled.span`
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  text-align: center;
  background: var(--colWhite);
  padding: 12px 0;
  border: 1px solid #e8e8e8;
  border-radius: 5px;
  width: 100%;
`
export const CartBtnRight = styled.span`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  padding: 12px 0;
  text-align: center;
  background: #000;
  border-radius: 5px;
  width: 100%;
  color: var(--colWhite);

  /* & .npay {
    width: 37px;
    height: 14px;
    & img {
      width: 100%;
      height: 100%;
    }
  } */
`

export const ModalTitle = styled.p`
  font-size: 20px;
  line-height: 24px;
  font-weight: 600;
  & span {
    font-size: 15px;
    line-height: 24px;
    display: inline-block;
  }
`

export const SelectBox = styled.div<{ show: boolean }>`
  position: relative;
  width: 100%;
  padding: 0px;
  margin-bottom: 16px;
  background-color: var(--colWhite);
  border: ${(props) => (props.show ? '1px solid var(--colBlack)' : '1px solid #e0e0e0')};
  border-radius: 6px;
  align-self: center;
  cursor: pointer;
`
export const Label = styled.label`
  flex: 1;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--colBlack);
`

export const LabelWrap = styled.div<{ show: boolean }>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 10px 12px 10px 14px;
  gap: 8px;
  height: 40px;
  border-bottom: ${(props) => (props.show ? '1px solid var(--colGray3)' : null)};
  & img {
    width: 16px;
    height: 16px;
  }
`

export const SelectOptions = styled.ul<{ show: boolean }>`
  height: auto;
  overflow: scroll;
  list-style: none;
  width: 100%;
  max-height: ${(props) => (props.show ? '168px' : '0')};
  padding: 0;
  border-radius: 8px;
  background-color: var(--colWhite);
  color: #000;
`
export const OptionBoxWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`
export const Option = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  line-height: 16px;
  font-weight: 600;
  height: 40px;
  padding: 0 14px;
  transition: background-color 0.2s ease-in;
  & img {
    width: 20px;
    height: 20px;
  }
  &:hover {
    background-color: var(--colWhite);
  }
  & p {
    color: var(--colBlack);
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
  & p.amount {
    color: var(--colGray76);
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
  }
  & p.soldout {
    color: var(--colGray5);
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
  & .restock_notification {
    display: flex;
    justify-content: flex-start;
    gap: 3px;
    align-items: center;
    min-width: 108px;
    & p {
      font-size: 13px;
      line-height: 16px;
      color: var(--colPointBlue);
      font-weight: 500;
    }
  }
`

export const NPay = styled.div`
  width: 100%;
  height: 48px;
  background: #00de5a;
  border: 1px solid #00c851;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  & p {
    font-size: 14px;
    font-weight: 600px;
    line-height: 16px;
  }
  & img {
    width: 46px;
  }
`

export const OptionBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`

export const OptionWrap = styled.div`
  width: 100%;
  background: var(--colGray1);
  border-radius: 10px;
  padding: 15px 16px;
  @media screen and (min-width: 768px) {
  }
`

export const OptionContentWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  & > img {
    width: 16px;
    height: 16px;
  }
`

export const OptionContentContent = styled.p`
  font-size: 14px;
  line-height: 16px;
  color: var(--colGray7);
  @media screen and (min-width: 768px) {
    font-size: 15px;
    font-weight: 400;
    line-height: 20px;
  }
`

export const OptionPrice = styled.p`
  font-size: 15px;
  line-height: 16px;
  color: var(--colBlack);
  font-weight: bold;
  @media screen and (min-width: 768px) {
    font-size: 16px;
    font-weight: 700;
    line-height: 20px;
  }
`

export const PriceWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  margin: 16px 0;
  & p.total_title {
    font-size: 16px;
    font-weight: 500;
    line-height: 24px;
    color: var(--colGray6);
  }
  & p.total_price {
    font-size: 18px;
    font-weight: 700;
    line-height: 24px;
    color: var(--colBlack);
  }
`
